'use strict';
import Customer from './customer';
import RegistrationHelper from './registrationHelper';
import { newModalFromString } from '../components/modal';

const SELECTORS = {
    btnEmailNext: '.js-btn-email-next',
    btnLoginSubmit: '.js-btn-login-submit',
    closeLoginPopup: '.js-close-login-popup, .tingle-modal',
    layerLoginTrigger: '.js-layer-login',
    emailInput: '#unified-email',
    loginFormError: '#login-form-error',
    emailError: '.js-email-error',
    passwordInput: '#login-form-password',
    passwordError: '.js-login-error',
    passwordWrapper: '.js-password-wrapper',
    rememberMeWrapper: '.js-remember-me-wrapper',
    resetPasswordWrapper: '.js-reset-password-wrapper',
    loginDescription: '.js-login-description',
    loginSubtitle: '.js-login-subtitle',
    socialSection: '.js-unified-social-section',
    phoneInput: '#unified-phone',
    phoneForm: '#unified-phone-form',
    phonePrefix: '#unified-phone-prefix',
    phoneNextBtn: '.js-btn-phone-next',
    prefixWheelModal: '.js-prefix-wheel-modal',
    prefixWheelBackdrop: '.js-prefix-wheel-backdrop',
    prefixWheel: '.js-prefix-wheel',
    prefixWheelClose: '.js-prefix-wheel-close',
    prefixWheelContinue: '.js-prefix-wheel-continue',
    prefixWheelOption: '.js-prefix-wheel-option',
    prefixMobileTrigger: '.js-prefix-mobile-trigger',
    phoneStepEmailRecap: '.js-phone-step-email',
    phoneCsrfToken: '#unified-phone-csrf-token',
    phoneError: '#reg-phone-error',
    phoneOtpInput: '#unified-phone-otp',
    phoneOtpWrapper: '.js-unified-phone-otp-wrapper',
    phoneOtpError: '#reg-phone-otp-error',
    phoneOtpProceedButton: '.js-registrationModal__formBtn',
    stepEmail: '.js-step-email',
    stepPhone: '.js-step-phone',
    stepRegister: '.js-step-register',
    allSteps: '.js-unified-step',
    checkEmailUrlHolder: '#checkEmailURL',
    phoneCheckUrlHolder: '#phoneCheckURL',
    btnStepBack: '.js-unified-step-back',
    regEmailRecap: '.js-register-step-email',
    regPhoneRecap: '.js-register-step-phone',
    regFirstName: '#registration-form-fname',
    regLastName: '#registration-form-lname',
    regDob: '#dpReg',
    regGender: '#gender',
    genderMobileField: '.js-gender-mobile-field',
    genderMobileInput: '#gender-native-mobile',
    genderWheelModal: '.js-gender-wheel-modal',
    genderWheelBackdrop: '.js-gender-wheel-backdrop',
    genderWheel: '.js-gender-wheel',
    genderWheelOption: '.js-gender-wheel-option',
    genderWheelClose: '.js-gender-wheel-close',
    genderWheelContinue: '.js-gender-wheel-continue',
    dobDay: '#dob-day',
    dobMonth: '#dob-month',
    dobYear: '#dob-year',
    dobWrapper: '.js-dob-wrapper',
    dobMobile: '#dob-native-mobile',
    dobMobileField: '.js-dob-mobile-field',
    dobWheelModal: '.js-dob-wheel-modal',
    dobWheelBackdrop: '.js-dob-wheel-backdrop',
    dobWheel: '.js-dob-wheel',
    dobWheelOption: '.js-dob-wheel-option',
    dobWheelClose: '.js-dob-wheel-close',
    dobWheelContinue: '.js-dob-wheel-continue',
    dobError: '.js-dob-error',
    registerForm: '.registration-step-final',
    pageWrapper: '.js-unified-page-wrapper',
    herokuWarning: '.js-phone-heroku-warning',
    stepOtp: '.js-step-otp',
    otpConfirmBtn: '.js-register-otp',
    wrongOtpError: '.wrong-opt-inserted',
    expiredOtpError: '.expired-opt-inserted',
    otpErrorsWrapper: '.js-unified-otp-errors-wrapper',
    modalTitle: '.js-unified-title',
    unifiedLoyaltyRegistration: '.js-proceed-to-unified-loyalty-registration',
    alreadyRegisteredUserSubmitLoyaltyRegistration: '.js-unified-loyalty-registration-container form.registration-loyalty',
    privacyLink: '.js-unified-privacy-link',
    stepPrivacy: '.js-step-privacy-policy',
    privacyContent: '.js-privacy-policy-content',
    resetPasswordLink: '.js-unified-reset-password',
    stepResetPassword: '.js-step-reset-password',
    resetPasswordRequest: '.js-reset-password-request',
    resetPasswordForm: '#unified-reset-password-form',
    resetPasswordSubmitBtn: '.js-btn-reset-password-submit, .js-btn-reset-password-resend-link',
    resetPasswordEmail: '#unified-reset-password-email',
    resetPasswordEmailError: '.js-reset-password-email-error',
    resetPasswordGenericError: '.js-reset-password-generic-error',
    resetPasswordSuccess: '.js-reset-password-success',
    resetPasswordSuccessBody: '.js-reset-password-success-body',
    resetPasswordCloseBtn: '.js-reset-password-close',
    infoTooltipTrigger: '.js-info-tooltip-dynamic'
};

const GENDER_MAP = {
    'M': '1',
    'F': '2',
    'X': '3',
    'U': '4'
};

/**
 * Maps the gender value (M/F or others) to its numeric representation
 * @param {string|number} gender - Gender value
 * @returns {string} Mapped gender value
 */
function mapGender (gender) {
    if (!gender) return '';
    var genderStr = String(gender).toUpperCase();
    return GENDER_MAP[genderStr] || genderStr;
}

class RegistrationApi {
    constructor () {
        this.currentRequest = null;
    }

    checkEmail (emailAddress, url) {
        if (this.currentRequest) {
            this.currentRequest.abort();
        }
        this.currentRequest = $.ajax({
            url: url,
            type: 'GET',
            dataType: 'json',
            data: { emailAddress: emailAddress }
        });
        return this.currentRequest;
    }

    checkPhone (data, url) {
        if (this.currentRequest) {
            this.currentRequest.abort();
        }
        this.currentRequest = $.ajax({
            url: url,
            type: 'POST',
            dataType: 'json',
            data: data
        });
        return this.currentRequest;
    }
}

class UnifiedRegistration {
    constructor () {
        this.api = new RegistrationApi();
        this.isSubmitting = false;
        this.privacyReturnStep = null;
        this.privacyReturnBtnStepBack = false;
        this.resetPasswordReturnStep = null;
        this.resetPasswordReturnTitle = null;
        this.currentRegistrationOrDeleteStage = '';
        this.isSocialResetState = false;
        this.dobWheelScrollTimers = {};
        this.isDobWheelInitializing = false;
        this.prefixWheelScrollTimer = null;
        this.genderWheelScrollTimer = null;
        this.$activeDobModal = null;
        this.$activeDobWheels = null;
        this.socialName = '';
    }

    isModal () {
        return $(SELECTORS.pageWrapper).length === 0;
    }

    // ─── Analytics (NEW REG FLOW) ────────────────────────────────────────────

    getRegFlowPosition () {
        return this.isModal() ? 'modal' : 'landing_page';
    }

    /**
     * - country without loyalty: "only_registration"
     * - loyalty country excluded from implicit loyalty: depends on the loyalty flag
     * - loyalty country with implicit loyalty: always "profile_loyalty"
     * @returns {string} type of account
     */
    getTypeOfAccount () {
        if ($('#hasCurrentCountryLoyalty').val() !== 'true') {
            return 'only_registration';
        }
        if ($('#isCountryExcludedFromImplicitLoyalty').val() === 'true') {
            return $(SELECTORS.stepRegister).find('.loyalty-flag').first().is(':checked') ? 'profile_loyalty' : 'only_registration';
        }
        return 'profile_loyalty';
    }

    /**
     * Triggers a registration step analytics event, including client-side validation errors (no AJAX call).
     * @param {string} eventName - customer:registerFirst / customer:registerSecond / customer:registerThird
     * @param {boolean} isError - step result
     * @param {Object} [extraData] - additional trigger data
     */
    trackRegistrationStep (eventName, isError, extraData) {
        var isSocial = $('#isSocialRegistration').val() === 'true';
        $('body').trigger(eventName, $.extend({
            'type': 'registration',
            'status': isError ? 'error' : 'success',
            'regFlowPosition': this.getRegFlowPosition(),
            'isSocial': isSocial,
            'socialName': isSocial ? (this.socialName || '') : '',
            'data': {
                'error': !!isError
            }
        }, extraData));
    }

    trackConfirmOptin (isError) {
        $('body').trigger('analytics:registerConfirmOptin', {
            'error': !!isError,
            'typeOfAccount': this.getTypeOfAccount(),
            'regFlowPosition': this.getRegFlowPosition()
        });
    }

    trackAccountError (errorMsg) {
        $('body').trigger('customer:account_error', {
            type: 'login',
            step: 'step1_email',
            errorMsg: errorMsg
        });
    }

    init () {
        var _self = this;
        var ns = '.unifiedRegistration';

        $('body').off(ns)
            .on('click' + ns, SELECTORS.btnEmailNext, function (e) {
                _self.handleEmailNext(e);
            })

            .on('submit' + ns, '#unified-login-form', function (e) {
                if ($(SELECTORS.btnEmailNext).is(':visible')) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    _self.handleEmailNext(e);
                    return false;
                }
            })
            .on('click' + ns, SELECTORS.btnStepBack, function (e) {
                _self.handleStepBack(e);
            })

            .on('click' + ns, '.js-unified-page-step-header-wrapper a[href^="javascript:history.back"]', function (e) {
                _self.handleStepBack(e);
            })
            .on('click' + ns, SELECTORS.phoneNextBtn, function (e) {
                _self.handlePhoneNext(e);
            })
            .on('click touchstart' + ns, '.form-fields-item__clearIcon', function (e) {
                _self.handleInputClear(e);
            })
            .on('click' + ns, SELECTORS.unifiedLoyaltyRegistration, function (e) {
                _self.proceedToUnifiedRegistrationLoyaltyInit(e);
            })
            .on('click' + ns, '.js-unified-account-delete-button', function () {
                _self.confirmationDeleteAccount();
            })
            .on('click' + ns, '#unifiedAccountDeleteConfirmModalYes', function () {
                _self.handleAccountDeleteConfirmation();
            })
            .on('click' + ns, '#accountEnrollToLoyalty', function (e) {
                _self.proceedToUnifiedRegistrationLoyaltyInit();
            })
            .on('click' + ns, '.js-opposition-tooltip-trigger', function (e) {
                e.preventDefault();
                e.stopPropagation();

                function onClose () {
                    if ($('.tingle-modal.tingle-modal--visible').length > 0) {
                        $('body').addClass('tingle-enabled');
                        $('html').addClass('html-tingle-enabled');
                    }
                    _self.activeOppositionModal = null;
                }

                var modalHtml = $('.js-opposition-mobile-modal-content').html();
                const modal = newModalFromString(
                    modalHtml,
                    false,
                    ['cc-opposition-tingle-modal'],
                    null,
                    onClose
                );

                _self.activeOppositionModal = modal;
                modal.open();

                $(modal.modalBox).find('.js-opposition-close-modal').on('click', function (e) {
                    e.preventDefault();
                    modal.close();
                });
            })
            .on('input' + ns, SELECTORS.phoneInput, function () {
                _self.handlePhoneInputChange();
            })
            .on('input change' + ns, '#registration-form-fname, #registration-form-lname, #registration-form-password, #registration-form-password-confirm', function () {
                _self.updateButtonStatus();
            })
            .on('change' + ns, '.loyalty-flag', function () {
                var isChecked = $(this).is(':checked');
                if (isChecked) {
                    $('.dob').removeClass('hidden');
                    $(SELECTORS.dobDay + ', ' + SELECTORS.dobMonth + ', ' + SELECTORS.dobYear + ', #dob-native-mobile').attr('required', 'required');
                    $('.opposition').removeClass('hidden');
                } else {
                    $('.dob').addClass('hidden');
                    $(SELECTORS.dobDay + ', ' + SELECTORS.dobMonth + ', ' + SELECTORS.dobYear + ', #dob-native-mobile').removeAttr('required');
                    $('.opposition').addClass('hidden');
                }
                _self.updateButtonStatus();
            })
            .on('changeDate change input' + ns, '#dpReg, .dob', function () {
                _self.updateButtonStatus();
            })
            .on('unifiedRegistration:socialRegistration' + ns, function (e, data) {
                _self.handleSocialRegistrationTransition(data);
            })
            .on('input' + ns, '.js-dob-part', function () {
                $(SELECTORS.dobDay + ', ' + SELECTORS.dobMonth + ', ' + SELECTORS.dobYear).removeClass('parsley-error is-invalid');
                $(SELECTORS.dobMobile).removeClass('parsley-error is-invalid');
                $(SELECTORS.dobMobileField).removeClass('is-invalid').attr('aria-invalid', 'false');
                $(SELECTORS.dobError).text('').hide();
                _self.assembleDob();
                _self.syncNativeMobileDateFromSplit();
                _self.updateButtonStatus();

                if (this.value.length === parseInt(this.getAttribute('maxlength'), 10)) {
                    var $inputs = $(this).closest('.js-dob-grid').find('.js-dob-part');
                    if (!$inputs.length) {
                        $inputs = $(this).closest('.cc-registrationModal__dob-grid').find('.js-dob-part');
                    }
                    $inputs.eq($inputs.index(this) + 1).focus();
                }
            })
            .on('focusout' + ns, '#dob-day, #dob-month, #dob-year', function () {
                var day = $(SELECTORS.dobDay).val().trim();
                var month = $(SELECTORS.dobMonth).val().trim();
                var year = $(SELECTORS.dobYear).val().trim();

                if (day.length > 0 && month.length > 0 && year.length > 0) {
                    _self.validateDob();
                }
            })
            .on('input change' + ns, '#dob-native-mobile', function () {
                var val = $(this).val();
                if (val) {
                    var parts = val.split('-');
                    if (parts.length === 3) {
                        $(SELECTORS.dobDay).val(parts[2]);
                        $(SELECTORS.dobMonth).val(parts[1]);
                        $(SELECTORS.dobYear).val(parts[0]);
                        $(SELECTORS.dobDay + ', ' + SELECTORS.dobMonth + ', ' + SELECTORS.dobYear).removeClass('parsley-error is-invalid');
                        $(SELECTORS.dobMobile).removeClass('parsley-error is-invalid');
                        $(SELECTORS.dobMobileField).removeClass('is-invalid').attr('aria-invalid', 'false');
                        $(SELECTORS.dobError).text('').hide();
                        _self.assembleDob();
                        _self.updateLoyaltyCtaStatus();
                        _self.updateButtonStatus();
                    }
                }
            })
            .on('invalid' + ns, SELECTORS.dobMobile + ', ' + SELECTORS.dobDay + ', ' + SELECTORS.dobMonth + ', ' + SELECTORS.dobYear, function (e) {
                e.preventDefault();
                _self.showDobError($(this).data('parsley-required-message') || '');
            })
            .on('click' + ns, SELECTORS.dobMobile, function () {
                _self.openDobWheelPicker($(this));
            })
            .on('click' + ns, SELECTORS.dobWheelClose, function () {
                _self.closeDobWheelPicker();
            })
            .on('click' + ns, SELECTORS.dobWheelContinue, function () {
                _self.applyDobWheelPicker();
            })
            .on('click' + ns, SELECTORS.dobWheel + ' .cc-wheel__option, .cc-dob-wheel__option', function (e) {
                e.preventDefault();
                var $option = $(this);
                var $wheel = $option.closest(SELECTORS.dobWheel);
                var wheelType = $wheel.data('wheel');
                _self.selectDobWheelOption($wheel, $option);
                if (wheelType === 'month' || wheelType === 'year') {
                    setTimeout(function () {
                        _self.updateDobWheelDayRange();
                    }, 200);
                }
            })
            .on('submit' + ns, SELECTORS.alreadyRegisteredUserSubmitLoyaltyRegistration, function (e) {
                _self.handleLoyaltyRegisterSubmit(e);
            })
            .on('click' + ns, SELECTORS.registerForm + ' button[type="submit"]', function () {
                _self.handleRegisterSubmitClick(this);
            })
            .on('submit' + ns, SELECTORS.registerForm, function (e) {
                e.preventDefault();
                _self.handleRegisterSubmit(e);
            })
            .on('keyup input' + ns, '.otp-code-input-field', function (e) {
                _self.handleOtpKeyup(e, this);
            })
            .on('paste' + ns, '.otp-code-input-field', function (e) {
                e.preventDefault();
                var clipboardData = e.originalEvent.clipboardData || window.clipboardData;
                if (!clipboardData) return;
                var pastedText = clipboardData.getData('Text') || clipboardData.getData('text/plain') || '';

                var digits = pastedText.replace(/[^0-9]/g, '').split('');
                if (digits.length === 0) return;

                var $inputs = $('.otp-code-input-field');
                var pasteStartIndex = $inputs.index($(this));

                for (var i = 0; i < digits.length && (pasteStartIndex + i) < $inputs.length; i++) {
                    var $nextInput = $inputs.eq(pasteStartIndex + i);
                    $nextInput.val(digits[i]);
                }

                var lastIndex = Math.min(pasteStartIndex + digits.length - 1, $inputs.length - 1);
                var $lastFilledInput = $inputs.eq(lastIndex);
                $lastFilledInput.focus();

                _self.handleOtpKeyup(e, $lastFilledInput[0]);
            })
            .on('click' + ns, SELECTORS.otpConfirmBtn, function (e) {
                _self.handleOtpConfirm(e);
            })
            .on('click' + ns, SELECTORS.privacyLink, function (e) {
                e.preventDefault();
                _self.openPrivacyPolicy($(e.currentTarget).data('url'));
            })
            .on('click' + ns, SELECTORS.resetPasswordLink, function (e) {
                e.preventDefault();
                _self.openResetPassword();
            })
            .on('click' + ns, SELECTORS.resetPasswordSubmitBtn, function (e) {
                e.preventDefault();
                _self.handleResetPasswordSubmit(e);
            })
            .on('input change' + ns, SELECTORS.resetPasswordEmail, function () {
                _self.handleResetPasswordInputChange($(this));
            })
            .on('click' + ns, SELECTORS.resetPasswordCloseBtn, function (e) {
                e.preventDefault();
                if (_self.isModal()) {
                    $('.js-close-login-popup').trigger('click');
                } else {
                    _self.closeResetPassword();
                }
            })
            .on('click' + ns, '.cc-unified-close-success-registration', function (e) {
                e.preventDefault();
                if (_self.isModal()) {
                    $('.js-close-login-popup').trigger('click');
                } else {
                    window.location.href = $(this).data('home-url');
                }
            })
            .on('input' + ns, '#registration-form-password', function () {
                _self.handlePasswordInput();
            })
            .on('input change' + ns, SELECTORS.passwordInput, function () {
                _self.handleLoginPasswordInputChange();
            })
            .on('input change' + ns, '.cc-asterisk-pwd-input-value', function () {
                _self.updatePasswordOverlay($(this));
            })
            .on('focusin' + ns, '#registration-form-password', function () {
                $('.js-password-tip-static').addClass('hidden');
                $('.js-password-checklist').removeClass('hidden');
            })
            .on('focusout' + ns, '#registration-form-password', function () {
                var val = $(this).val() || '';
                if (val.length === 0) {
                    $('.js-password-tip-static').removeClass('hidden');
                    $('.js-password-checklist').addClass('hidden');
                }
            })
            .on('focusout' + ns, '#registration-form-password-confirm', function () {
                var $pwd = $('#registration-form-password');
                var $confirm = $(this);
                if ($pwd.val().length > 0 && $confirm.val().length > 0) {
                    $confirm.parsley().validate();
                }
            })
            .on('input' + ns, '#registration-form-password-confirm', function () {
                var $confirm = $(this);
                $confirm.removeClass('is-invalid parsley-error');
                $confirm.siblings('.errors-list').find('.form-error').text('').hide();
            })
            .on('change' + ns, '.add-to-email', function (e) {
                $('.js-personalized-news-container').removeClass('transparent');
                if (e.target.id === 'add-to-email-list-yes' && e.target.checked) {
                    $('.add-to-personalized-list').prop('disabled', false);
                    if (e.target.value != null && e.target.value) {
                        $('.add-to-personalized-list').prop('required', true);
                    } else {
                        $('.add-to-personalized-list').removeAttr('required');
                    }
                } else {
                    $('.add-to-personalized-list').prop('checked', false);
                    $('.add-to-personalized-list').prop('disabled', true);
                    $('.add-to-personalized-list').removeAttr('required');
                    $('.js-personalized-news-container').addClass('transparent');
                }
            })
            .on('mouseenter' + ns, SELECTORS.infoTooltipTrigger, function () {
                if (_self.isTouchCapable()) return;
                _self.showInfoTooltip($(this));
            })
            .on('mouseleave' + ns, SELECTORS.infoTooltipTrigger, function () {
                if (_self.isTouchCapable()) return;
                _self.hideInfoTooltip($(this));
            })
            .on('focus' + ns, SELECTORS.infoTooltipTrigger, function () {
                if (_self.isTouchCapable()) return;
                _self.showInfoTooltip($(this));
            })
            .on('blur' + ns, SELECTORS.infoTooltipTrigger, function () {
                if (_self.isTouchCapable()) return;
                _self.hideInfoTooltip($(this));
            })
            .on('click' + ns, SELECTORS.infoTooltipTrigger, function (e) {
                e.preventDefault();
                e.stopPropagation();

                if (!_self.isTouchCapable()) return;

                var $wrapper = $(this);
                var $tooltip = $wrapper.children('.tooltip');
                var isOpen = $tooltip.hasClass('is-visible');

                $(SELECTORS.infoTooltipTrigger).not($wrapper).each(function () {
                    _self.hideInfoTooltip($(this));
                });

                if (isOpen) {
                    _self.hideInfoTooltip($wrapper);
                } else {
                    $tooltip.addClass('is-visible');
                    window.requestAnimationFrame(function () {
                        _self.positionInfoTooltip($wrapper);
                    });
                }
            })
            .on('click' + ns, function (e) {
                if (!$(e.target).closest(SELECTORS.infoTooltipTrigger).length) {
                    $(SELECTORS.infoTooltipTrigger).each(function () {
                        _self.hideInfoTooltip($(this));
                    });
                }
            })
            .on('change' + ns, SELECTORS.phonePrefix, function () {
                _self.updatePrefixDisplay();
            })
            .on('click' + ns, SELECTORS.prefixMobileTrigger, function (e) {
                e.preventDefault();
                _self.openPrefixWheelPicker();
            })
            .on('click' + ns, SELECTORS.prefixWheelClose, function (e) {
                e.preventDefault();
                _self.closePrefixWheelPicker();
            })
            .on('click' + ns, SELECTORS.prefixWheelContinue, function (e) {
                e.preventDefault();
                _self.applyPrefixWheelPicker();
            })
            .on('click' + ns, SELECTORS.prefixWheelOption, function (e) {
                e.preventDefault();
                var $option = $(this);
                var $wheel = $option.closest(SELECTORS.prefixWheel);
                _self.selectPrefixWheelOption($wheel, $option, true);
            })
            .on('click' + ns, SELECTORS.genderMobileField + ', ' + SELECTORS.genderMobileInput, function (e) {
                e.preventDefault();
                _self.openGenderWheelPicker();
            })
            .on('click' + ns, SELECTORS.genderWheelClose, function (e) {
                e.preventDefault();
                _self.closeGenderWheelPicker();
            })
            .on('click' + ns, SELECTORS.genderWheelContinue, function (e) {
                e.preventDefault();
                _self.applyGenderWheelPicker();
            })
            .on('click' + ns, SELECTORS.genderWheelOption, function (e) {
                e.preventDefault();
                var $option = $(this);
                var $wheel = $option.closest(SELECTORS.genderWheel);
                _self.selectGenderWheelOption($wheel, $option, true);
            })
            .on('change' + ns, 'input[id^="gender-"]', function () {
                _self.syncNativeMobileGenderFromRadio();
                _self.updateButtonStatus();
            });

        $(window).off(ns).on('resize' + ns + ' orientationchange' + ns, function () {
            $(SELECTORS.infoTooltipTrigger).each(function () {
                var $wrapper = $(this);
                if ($wrapper.children('.tooltip').hasClass('is-visible')) {
                    window.requestAnimationFrame(function () {
                        _self.positionInfoTooltip($wrapper);
                    });
                }
            });
        });

        _self.syncNativeMobileDateFromSplit();
        _self.syncNativeMobileGenderFromRadio();

        // Initialize original-label on load
        var $emailNextBtn = $(SELECTORS.btnEmailNext);
        if ($emailNextBtn.length) {
            $emailNextBtn.data('original-label', $emailNextBtn.text().trim());
        }

        // Handle typing on email input to reset social error / mode
        $('body').on('input change' + ns, SELECTORS.emailInput, function () {
            if (_self.isSocialResetState) {
                _self.isSocialResetState = false;
                var originalLabel = $(SELECTORS.btnEmailNext).data('original-label');
                $(SELECTORS.btnEmailNext).text(originalLabel);
            }
            // Clear only the error state, do NOT clear the input value!
            $(SELECTORS.emailInput).removeClass('parsley-error is-invalid');
            $(SELECTORS.emailError).text('').hide();
            _self.handleEmailInputChange();
        });

        $('.cc-asterisk-pwd-wrapper .cc-asterisk-pwd-input-value').each(function () {
            _self.updatePasswordOverlay($(this));
        });
    }

    // ─── Step 1: Email ───────────────────────────────────────────────────────

    handleEmailNext (e) {
        e.preventDefault();
        if (this.isSubmitting) return;

        var $emailInput = $(SELECTORS.emailInput);
        var $emailError = $(SELECTORS.emailError);

        if (!this.validateEmail($emailInput)) {
            if (!this.isSocialResetState) {
                this.trackRegistrationStep('customer:registerFirst', true);
            }
            return;
        }

        var emailVal = $emailInput.val().trim();

        if (this.isSocialResetState) {
            this.handleSocialResetPassword(emailVal, $emailInput, $emailError);
            return;
        }

        var url = $(SELECTORS.checkEmailUrlHolder).data('url');
        if (!url) {
            console.error('Unified Registration: Missing #checkEmailURL in DOM.');
            return;
        }

        this.checkEmailAjax(emailVal, url, $emailInput, $emailError);
    }

    handleSocialResetPassword (emailVal, $emailInput, $errorEl) {
        var _self = this;
        this.isSubmitting = true;
        $.spinner().start();

        var $form = $(SELECTORS.resetPasswordForm);
        $(SELECTORS.resetPasswordEmail).val(emailVal);

        $.ajax({
            url: $form.attr('action'),
            type: 'POST',
            dataType: 'json',
            data: $form.serialize()
        }).done(function (data) {
            $.spinner().stop();
            if (!data.success) {
                var errMsg = data.error || (data.fields && data.fields.loginEmail);
                _self.showValidationError($emailInput, $errorEl, errMsg);
                return;
            }

            // Transition to the unified Reset Password Success page
            _self.toggleVisible(SELECTORS.stepEmail, false);
            _self.toggleVisible(SELECTORS.stepResetPassword, true);
            _self.toggleVisible(SELECTORS.resetPasswordRequest, false);
            _self.toggleVisible(SELECTORS.resetPasswordSuccess, true);
            _self.toggleVisible(SELECTORS.btnStepBack, false);
            $(SELECTORS.resetPasswordSuccessBody).text(data.receivedMsgBody || '');
            _self.resetPasswordReturnStep = $(SELECTORS.stepEmail);
            _self.resetPasswordReturnTitle = $(SELECTORS.modalTitle).text();
            $(SELECTORS.modalTitle).text($(SELECTORS.modalTitle).data('reset-password-title') || '');
        }).fail(function () {
            $.spinner().stop();
            var errMsg = $emailInput.data('error-generic');
            _self.showValidationError($emailInput, $errorEl, errMsg);
        }).always(function () {
            _self.isSubmitting = false;
        });
    }

    validateEmail ($emailInput) {
        var parsleyField = $emailInput.parsley();
        parsleyField.validate();
        return parsleyField.isValid();
    }

    checkEmailAjax (emailVal, url, $emailInput, $emailError) {
        var _self = this;
        this.isSubmitting = true;
        $.spinner().start();

        this.api.checkEmail(emailVal, url)
            .done(function (data) {
                $.spinner().stop();

                if (data.credentialsEnabled === false) {
                    var msg = data.errorMsg ? data.errorMsg[0] : '';
                    $(SELECTORS.loginFormError).html(msg).addClass('login-form-error-block').show();
                    _self.isSubmitting = false;

                    _self.trackAccountError('account_created_but_not_activated_yet');

                    // Analytics tracking Step 1 Error
                    _self.trackRegistrationStep('customer:registerFirst', true);
                    return;
                }

                if (!data.success) {
                    var msg = data.message || $emailInput.data('parsley-type-message') || '';
                    _self.showValidationError($emailInput, $emailError, msg);

                    // Analytics tracking Step 1 Error
                    _self.trackRegistrationStep('customer:registerFirst', true);
                    return;
                }

                if (data.exists) {
                    if (data.isSocial) {
                        var socialErrorMsg = data.socialErrorMsg;
                        _self.showValidationError($emailInput, $emailError, socialErrorMsg);

                        // Analytics tracking Step 1 Error (email already associated to a social profile)
                        _self.trackRegistrationStep('customer:registerFirst', true);

                        // Set state and change button text to "Send"
                        _self.isSocialResetState = true;
                        var btnLabel = data.socialResetBtnLabel;
                        $(SELECTORS.btnEmailNext).text(btnLabel);
                        return;
                    }
                    _self.transitionToLogin(emailVal);
                    return;
                }

                // Analytics tracking Step 1 Success
                _self.trackRegistrationStep('customer:registerFirst', false);

                _self.transitionToPhone(data.hiddenPhonePlaceholder);
            })
            .fail(function (jqXHR) {
                $.spinner().stop();
                if (jqXHR.statusText === 'abort') return;
                var msg = $emailInput.data('error-generic') || '';
                _self.showValidationError($emailInput, $emailError, msg);

                // Analytics tracking Step 1 Error
                _self.trackRegistrationStep('customer:registerFirst', true);
            })
            .always(function () {
                _self.isSubmitting = false;
            });
    }

    // ─── Login state (existing user) ─────────────────────────────────────────

    transitionToLogin (emailVal) {
        var $emailInput = $(SELECTORS.emailInput);
        if (emailVal) $emailInput.val(emailVal);
        $emailInput.attr('readonly', 'readonly').addClass('cc-is-readonly');

        this.toggleVisible(SELECTORS.loginDescription, true);
        this.toggleVisible(SELECTORS.loginSubtitle, false);
        this.toggleVisible(SELECTORS.passwordWrapper, true);
        this.toggleVisible(SELECTORS.resetPasswordWrapper, true);
        this.toggleVisible(SELECTORS.rememberMeWrapper, true);
        this.toggleVisible(SELECTORS.btnLoginSubmit, true);
        this.toggleVisible(SELECTORS.btnEmailNext, false);
        this.toggleVisible(SELECTORS.socialSection, false);
        this.toggleVisible(SELECTORS.btnStepBack, true);
        $(SELECTORS.passwordInput).focus();
        this.handleLoginPasswordInputChange();
        this.updatePasswordOverlay($('.cc-asterisk-pwd-wrapper ' + SELECTORS.passwordInput));
    }

    // ─── Step 2: Phone ───────────────────────────────────────────────────────

    transitionToPhone (hiddenPhonePlaceholder) {
        this.updateHeaderTitle('register');
        $(SELECTORS.phoneStepEmailRecap).text($(SELECTORS.emailInput).val().trim());
        this.toggleVisible(SELECTORS.stepEmail, false);
        this.toggleVisible(SELECTORS.stepPhone, true);
        this.toggleVisible(SELECTORS.btnStepBack, true);
        this.initPhonePrefixChosen();
        this.updatePrefixDisplay();

        $('body').addClass('cc-unified-step-active');

        var $phoneInput = $(SELECTORS.phoneInput);
        if (!$phoneInput.length) return;

        if (hiddenPhonePlaceholder) {
            $phoneInput.attr('placeholder', hiddenPhonePlaceholder);
            $phoneInput.data('exists-on-heroku', true);
            this.toggleVisible(SELECTORS.herokuWarning, true);
            return;
        }

        $phoneInput.attr('placeholder', '');
        $phoneInput.data('exists-on-heroku', false);
        this.toggleVisible(SELECTORS.herokuWarning, false);
        $phoneInput.focus();
    }

    handleSocialRegistrationTransition (data) {
        var socialMail = data.socialMail || '';

        // Set isSocialRegistration hidden input to true
        $('#isSocialRegistration').val('true');
        // Gigya provider, used by the social registration analytics
        this.socialName = data.socialName || '';

        // 1. Set email input and lock it as readonly
        var $emailInput = $(SELECTORS.emailInput);
        if (socialMail) {
            $emailInput.val(socialMail);
        }
        $emailInput.attr('readonly', 'readonly').addClass('cc-is-readonly');

        // 3. Transition to Step 2
        this.transitionToPhone();

        // 4. Update the Step 2 "Next" button status
        this.handlePhoneInputChange();
    }

    handlePhoneInputChange () {
        var isFilled = $(SELECTORS.phoneInput).val() !== '';
        $(SELECTORS.phoneNextBtn).prop('disabled', !isFilled);
    }

    handlePhoneNext (e) {
        e.preventDefault();
        if (this.isSubmitting) return;

        var $form = $(SELECTORS.phoneForm);
        $form.parsley().validate();
        if (!$form.parsley().isValid()) {
            $(SELECTORS.phoneNextBtn).prop('disabled', true);
            // Analytics tracking Step 2 Error (client-side validation)
            this.trackRegistrationStep('customer:registerSecond', true);
            return;
        }

        var $otpInput = $(SELECTORS.phoneOtpInput);
        var $otpWrapper = $(SELECTORS.phoneOtpWrapper);
        var isOtpVisible = $otpWrapper.length && !$otpWrapper.hasClass('hidden');

        if (isOtpVisible) {
            $otpInput.parsley().validate();
            if (!$otpInput.parsley().isValid()) {
                // Analytics tracking Step 2 Error (client-side validation)
                this.trackRegistrationStep('customer:registerSecond', true);
                return;
            }
        }

        var url = $(SELECTORS.phoneCheckUrlHolder).data('url');
        if (!url) {
            console.error('Unified Registration: Missing #phoneCheckURL in DOM.');
            return;
        }

        // Serialize the form to exactly mimic the legacy form post parameters binding
        var $phoneForm = $(SELECTORS.phoneForm);
        var postData = $phoneForm.serialize();
        postData += '&loginEmail=' + encodeURIComponent($(SELECTORS.emailInput).val().trim());
        postData += '&isModalFlow=' + this.isModal();

        $(SELECTORS.phoneError).empty().removeClass('login-form-error-block');

        var _self = this;
        this.isSubmitting = true;
        $.spinner().start();

        this.api.checkPhone(postData, url)
            .done(function (data) {
                $.spinner().stop();
                if (data.success) {
                    // Analytics tracking Step 2 Success
                    _self.trackRegistrationStep('customer:registerSecond', false);

                    _self.transitionToRegister(data.existsInHeroku ? data.customerData : null, data.hideDob);
                } else if (data.phone2Opt) {
                    $otpWrapper.removeClass('hidden');
                    $(SELECTORS.phoneOtpProceedButton).addClass('underline-border');
                    $otpInput.attr('required', 'required').focus();
                    if (data.error && data.error.length > 0) {
                        var errMsg = Array.isArray(data.error) ? data.error.join('<br/>') : data.error;
                        $(SELECTORS.phoneOtpError).html(errMsg).show();

                        // Analytics tracking Step 2 Error (wrong phone OTP)
                        _self.trackRegistrationStep('customer:registerSecond', true);
                    } else {
                        $(SELECTORS.phoneOtpError).empty().hide();
                    }
                } else {
                    var errMsg = data.error
                        ? (Array.isArray(data.error) ? data.error.join('<br/>') : data.error)
                        : (data.message || '');

                    // Analytics tracking Step 2 Error
                    _self.trackRegistrationStep('customer:registerSecond', true);

                    _self.showPhoneError(errMsg);
                    $(SELECTORS.phoneNextBtn).prop('disabled', true);
                }
            })
            .fail(function (jqXHR) {
                $.spinner().stop();
                if (jqXHR.statusText !== 'abort') {
                    // Analytics tracking Step 2 Error
                    _self.trackRegistrationStep('customer:registerSecond', true);

                    _self.showPhoneError('');
                    $(SELECTORS.phoneNextBtn).prop('disabled', true);
                }
            })
            .always(function () {
                _self.isSubmitting = false;
            });
    }

    /**
     * Display or hide the phone registration error block.
     * - Case 1 (Modal Flow): Modal cloning duplicates IDs #reg-phone-error in DOM (one hidden on page, one visible in modal). Targeting '.cc-step-phone:visible' guarantees updating the active modal error box.
     * - Case 2 (Standalone Flow): Rendered on a full page with only one #reg-phone-error in DOM.
     * - Empty/Falsy Value Handling: When an empty message is received (e.g., when clearing errors), the fallback block (else) empties the content and removes the error block styles (preventing empty red boxes).
     **/
    showPhoneError (msg) {
        var $errorEl = $('.cc-step-phone:visible').find(SELECTORS.phoneError);
        if (!$errorEl.length) {
            $errorEl = $(SELECTORS.phoneError);
        }

        if (msg) {
            $errorEl
                .html(msg)
                .addClass('login-form-error-block')
                .removeClass('success-block')
                .show();
        } else {
            $errorEl
                .empty()
                .removeClass('login-form-error-block')
                .hide();
        }
    }

    // ─── Step 3: Register ────────────────────────────────────────────────────

    transitionToRegister (herokuData, hideDob) {
        this.updateHeaderTitle('register');
        this.toggleVisible(SELECTORS.stepPhone, false);
        this.toggleVisible(SELECTORS.stepRegister, true);

        // Copy prefix and phone values to hidden fields of Step 3 for final SFCC submission
        $('.js-hidden-prefix').val($(SELECTORS.phonePrefix).val().trim());
        $('.js-hidden-phone').val($(SELECTORS.phoneInput).val().trim());

        $(SELECTORS.regEmailRecap).text($(SELECTORS.emailInput).val().trim());
        $(SELECTORS.regPhoneRecap).text(
            $(SELECTORS.phonePrefix).val().trim() + $(SELECTORS.phoneInput).val().trim()
        );

        // Hide/Show password fields based on whether it is a Social Registration
        var isSocial = $('#isSocialRegistration').val() === 'true';
        if (isSocial) {
            $('#registration-form-password').closest('.js-unified-registrationModal-finalFieldWrp').addClass('hidden');
            $('#registration-form-password-confirm').closest('.js-unified-registrationModal-finalFieldWrp').addClass('hidden');
            $('#registration-form-password').removeAttr('required');
            $('#registration-form-password-confirm').removeAttr('required');
        } else {
            $('#registration-form-password').closest('.js-unified-registrationModal-finalFieldWrp').removeClass('hidden');
            $('#registration-form-password-confirm').closest('.js-unified-registrationModal-finalFieldWrp').removeClass('hidden');
            $('#registration-form-password').attr('required', 'required');
            $('#registration-form-password-confirm').attr('required', 'required');
        }

        // Hide/Show DOB field based on hideDob parameter and country exclusion
        var isExcludedCountry = $('#isCountryExcludedFromImplicitLoyalty').val() === 'true';
        var $dobContainer = $(SELECTORS.dobWrapper).not('.cc-registrationModal__loyalty *').closest('.js-unified-registrationModal-finalFieldWrp');

        if (isExcludedCountry) {
            // Excluded country: top-level DOB is always hidden
            $dobContainer.addClass('hidden');

            // Toggle legacy DOB requirements based on the loyalty checkbox state
            var isLoyaltyChecked = $('.loyalty-flag').is(':checked');
            if (isLoyaltyChecked) {
                $('.dob').removeClass('hidden');
                $(SELECTORS.dobDay + ', ' + SELECTORS.dobMonth + ', ' + SELECTORS.dobYear + ', #dob-native-mobile').attr('required', 'required');
                $('.opposition').removeClass('hidden');
            } else {
                $('.dob').addClass('hidden');
                $(SELECTORS.dobDay + ', ' + SELECTORS.dobMonth + ', ' + SELECTORS.dobYear + ', #dob-native-mobile').removeAttr('required');
                $('.opposition').addClass('hidden');
            }
        } else {
            // Standard country: standard hideDob toggle
            if (hideDob) {
                $dobContainer.addClass('hidden');
                $(SELECTORS.dobDay + ', ' + SELECTORS.dobMonth + ', ' + SELECTORS.dobYear + ', #dob-native-mobile').removeAttr('required');
            } else {
                $dobContainer.removeClass('hidden');
                // Restore required attribute
                $(SELECTORS.dobDay + ', ' + SELECTORS.dobMonth + ', ' + SELECTORS.dobYear + ', #dob-native-mobile').attr('required', 'required');
            }
        }

        if (herokuData) {
            this.prefillRegisterForm(herokuData);
        } else {
            this.updateButtonStatus();
        }
        this.syncNativeMobileGenderFromRadio();
        this.updatePasswordOverlay($('.cc-asterisk-pwd-wrapper #registration-form-password'));
        this.updatePasswordOverlay($('.cc-asterisk-pwd-wrapper #registration-form-password-confirm'));
    }

    prefillRegisterForm (data) {
        if (data.firstName) $(SELECTORS.regFirstName).val(data.firstName);
        if (data.lastName) $(SELECTORS.regLastName).val(data.lastName);
        if (data.birthDate) {
            var parts = null;
            if (data.birthDate.indexOf('-') > -1) {
                parts = data.birthDate.split('T')[0].split('-');
            } else if (data.birthDate.indexOf('/') > -1) {
                parts = data.birthDate.split('/');
            }
            if (parts && parts.length === 3) {
                var day, month, year;
                if (parts[0].length === 4) {
                    year = parts[0];
                    month = parts[1];
                    day = parts[2];
                } else {
                    day = parts[0];
                    month = parts[1];
                    year = parts[2];
                }
                day = day.length === 1 ? '0' + day : day;
                month = month.length === 1 ? '0' + month : month;

                $(SELECTORS.dobDay).val(day);
                $(SELECTORS.dobMonth).val(month);
                $(SELECTORS.dobYear).val(year);
                $('#dob-native-mobile').val(day + '/' + month + '/' + year);
                this.assembleDob();
            }
        }
        if (data.gender) {
            var genderVal = mapGender(data.gender);
            $('[name="dwfrm_profile_customer_gender"][value="' + genderVal + '"]').prop('checked', true);
            this.syncNativeMobileGenderFromRadio();
        }
        if (data.directMarketingAgreement !== null && data.directMarketingAgreement !== undefined) {
            if (data.directMarketingAgreement === true) {
                $('#add-to-email-list-yes').prop('checked', true);
            } else {
                $('#add-to-email-list-no').prop('checked', true);
            }
        }
        if (data.profilingAgreement !== null && data.profilingAgreement !== undefined) {
            if (data.profilingAgreement === true) {
                $('#add-to-personalized-news-list-yes').prop('checked', true);
            } else {
                $('#add-to-personalized-news-list-no').prop('checked', true);
            }
        }
        this.updateButtonStatus();
    }

    updateButtonStatus () {
        var gender = $(SELECTORS.registerForm).find('input[id^="gender-"]:checked').val() || '';
        var isGenderValid = gender.trim() !== '' && gender !== '0';
        var fname = $(SELECTORS.regFirstName).val() || '';
        var lname = $(SELECTORS.regLastName).val() || '';
        var password = $('#registration-form-password').val() || '';
        var confirmPassword = $('#registration-form-password-confirm').val() || '';

        var isSocial = $('#isSocialRegistration').val() === 'true';

        var allFieldsFilled;
        if (isSocial) {
            allFieldsFilled = isGenderValid && fname.trim() !== '' && lname.trim() !== '';
        } else {
            allFieldsFilled = isGenderValid &&
                fname.trim() !== '' &&
                lname.trim() !== '' &&
                password.trim() !== '' &&
                confirmPassword.trim() !== '' &&
                password === confirmPassword;
        }

        // Under excluded country: if loyalty-flag is checked, birthDate (dob) must be filled
        var isExcludedCountry = $('#isCountryExcludedFromImplicitLoyalty').val() === 'true';
        if (isExcludedCountry && allFieldsFilled) {
            var isLoyaltyChecked = $('.loyalty-flag').is(':checked');
            if (isLoyaltyChecked) {
                var dobVal = $('#dpReg').val() || '';
                if (dobVal.trim() === '') {
                    allFieldsFilled = false;
                }
            }
        }

        if (!isSocial && password.length && confirmPassword.length) {
            var validPassword = this.validatePasswordStrength(password);
            var passwordsMatch = password === confirmPassword;
            allFieldsFilled = allFieldsFilled && validPassword && passwordsMatch;
        }

        if (allFieldsFilled) {
            $('.register-form-button').prop('disabled', false);
        } else {
            $('.register-form-button').prop('disabled', true);
        }
    }

    // ─── Date of Birth ───────────────────────────────────────────────────────

    assembleDob () {
        var day = $(SELECTORS.dobDay).val().trim();
        var month = $(SELECTORS.dobMonth).val().trim();
        var year = $(SELECTORS.dobYear).val().trim();
        var format = $(SELECTORS.dobWrapper).data('date-format-pattern') || 'dd-mm-yyyy';
        var assembled = '';

        if (day && month && year) {
            if (format === 'mm-dd-yyyy') {
                assembled = month + '-' + day + '-' + year;
            } else if (format === 'yyyy年mm月dd日') {
                assembled = year + '年' + month + '月' + day + '日';
            } else {
                assembled = day + '-' + month + '-' + year;
            }
        }

        $(SELECTORS.regDob).val(assembled);
    }

    syncNativeMobileDateFromSplit () {
        var day = $(SELECTORS.dobDay).length ? $(SELECTORS.dobDay).val().trim() : '';
        var month = $(SELECTORS.dobMonth).length ? $(SELECTORS.dobMonth).val().trim() : '';
        var year = $(SELECTORS.dobYear).length ? $(SELECTORS.dobYear).val().trim() : '';
        if (day && month && year) {
            var paddedDay = day.length === 1 ? '0' + day : day;
            var paddedMonth = month.length === 1 ? '0' + month : month;
            $('#dob-native-mobile').val(paddedDay + '/' + paddedMonth + '/' + year);
        }
    }

    // ══════════════════════════════════════════════════════════════════════════
    // MODULAR WHEEL PICKER (Mobile Bottom Sheet)
    // ══════════════════════════════════════════════════════════════════════════

    // ─── Shared Wheel Picker Engine ──────────────────────────────────────────

    scrollWheelToOption ($wheel, $option, smooth, onComplete) {
        if (!$wheel || !$wheel.length || !$option || !$option.length) return;
        var wheelEl = $wheel[0];
        var optionEl = $option[0];

        var wheelRect = wheelEl.getBoundingClientRect();
        var optionRect = optionEl.getBoundingClientRect();
        var offsetFromCenter = (optionRect.top + optionRect.height / 2) - (wheelRect.top + wheelRect.height / 2);
        var targetScrollTop = wheelEl.scrollTop + offsetFromCenter;

        var prevSnap = wheelEl.style.scrollSnapType;
        wheelEl.style.scrollSnapType = 'none';

        $wheel.stop(true, false).animate(
            { scrollTop: targetScrollTop },
            smooth === false ? 0 : 180,
            'swing',
            function () {
                wheelEl.style.scrollSnapType = prevSnap;
                if (typeof onComplete === 'function') {
                    onComplete();
                }
            }
        );
    }

    getWheelCenteredOption ($wheel, optionSelector) {
        if (!$wheel || !$wheel.length) return null;
        var wheelRect = $wheel[0].getBoundingClientRect();
        var wheelCenter = wheelRect.top + (wheelRect.height / 2);
        var closest = null;
        var minDistance = Infinity;

        $wheel.find(optionSelector).each(function () {
            var optRect = this.getBoundingClientRect();
            var optCenter = optRect.top + (optRect.height / 2);
            var distance = Math.abs(optCenter - wheelCenter);
            if (distance < minDistance) {
                minDistance = distance;
                closest = this;
            }
        });
        return closest;
    }

    // ─── Wheel Picker: Day of birth (3 Wheel) ────────────────────────

    openDobWheelPicker ($clickedInput) {
        var $mobileInput = $clickedInput || $(SELECTORS.dobMobile).filter(':visible').first();
        if (!$mobileInput.length || !$mobileInput.is(':visible')) return;

        this.isDobWheelInitializing = true;

        var year = parseInt($(SELECTORS.dobYear).val(), 10) || new Date().getFullYear() - 30;
        var month = parseInt($(SELECTORS.dobMonth).val(), 10) || 1;
        var day = parseInt($(SELECTORS.dobDay).val(), 10) || 1;
        var maxYear = new Date().getFullYear();

        // Find the specific modal and backdrop corresponding to the clicked input field
        var $modal = $mobileInput.data('$modal');
        var $backdrop = $mobileInput.data('$backdrop');

        if (!$modal || !$modal.length) {
            $modal = $mobileInput.closest(SELECTORS.dobWrapper).find(SELECTORS.dobWheelModal);
            $backdrop = $mobileInput.closest(SELECTORS.dobWrapper).find(SELECTORS.dobWheelBackdrop);
            $mobileInput.data('$modal', $modal);
            $mobileInput.data('$backdrop', $backdrop);
        }

        // Move to body if not already direct children of body to avoid layout transform containment issues
        if (!$modal.parent().is('body')) {
            $('body').append($modal).append($backdrop);
        }

        $modal.removeClass('hidden');
        $backdrop.removeClass('hidden');
        $('body').addClass('cc-dob-wheel-open');

        // Store active modal and wheels on the class instance!
        this.$activeDobModal = $modal;
        this.$activeDobWheels = {
            day: $modal.find(SELECTORS.dobWheel + '[data-wheel="day"]'),
            month: $modal.find(SELECTORS.dobWheel + '[data-wheel="month"]'),
            year: $modal.find(SELECTORS.dobWheel + '[data-wheel="year"]')
        };

        // Bind the scroll event directly to the active wheels!
        var ns = '.unifiedRegistration';
        var _self = this;
        $modal.find(SELECTORS.dobWheel).off('scroll' + ns).on('scroll' + ns, function () {
            if (_self.isDobWheelInitializing) return;
            var $wheel = $(this);
            var wheelType = $wheel.data('wheel');
            clearTimeout(_self.dobWheelScrollTimers[wheelType]);
            _self.dobWheelScrollTimers[wheelType] = setTimeout(function () {
                _self.markDobWheelSelection($wheel);
                if (wheelType === 'month' || wheelType === 'year') {
                    _self.updateDobWheelDayRange();
                }
            }, 80);
        });

        // Use traditional function to avoid any ES6 arrow function transpilation issues!
        window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
                _self.populateDobWheel('day', 1, _self.getDaysInMonth(year, month), day);
                _self.populateDobWheel('month', 1, 12, month);
                _self.populateDobWheel('year', maxYear - 120, maxYear, year);

                setTimeout(function () {
                    _self.isDobWheelInitializing = false;
                }, 300);
            });
        });
    }

    populateDobWheel (type, min, max, selected) {
        var $activeModal = $(SELECTORS.dobWheelModal).not('.hidden');
        var $wheel = $activeModal.find(SELECTORS.dobWheel + '[data-wheel="' + type + '"]');
        if (!$wheel.length) {
            $wheel = $(SELECTORS.dobWheel + '[data-wheel="' + type + '"]');
        }
        var fragment = document.createDocumentFragment();
        var formatter = new Intl.DateTimeFormat(document.documentElement.lang || undefined, {month: 'long'});
        var cycleSize = max - min + 1;
        var cycles = 5;

        for (var cycle = 0; cycle < cycles; cycle++) {
            for (var value = min; value <= max; value++) {
                var option = document.createElement('button');
                option.type = 'button';
                option.className = 'cc-wheel__option js-dob-wheel-option';
                option.dataset.value = value;
                option.textContent = type === 'month' ? formatter.format(new Date(2000, value - 1, 1)) : value;
                fragment.appendChild(option);
            }
        }

        $wheel.data('wheel-min', min).data('wheel-max', max).data('cycle-size', cycleSize);
        $wheel.empty().append(fragment);

        // Ensure browser layout has completed before calculating scroll dimensions!
        var _self = this;
        window.requestAnimationFrame(function () {
            _self.selectDobWheelValue($wheel, selected, cycleSize * 2);
        });
    }

    selectDobWheelValue ($wheel, value, startIndex) {
        var val = parseInt(value, 10);
        var min = parseInt($wheel.data('wheel-min'), 10);
        var start = parseInt(startIndex, 10);
        var index = start + val - min;
        var $option = $wheel.find(SELECTORS.dobWheelOption).eq(index);
        if (!$option.length) $option = $wheel.find(SELECTORS.dobWheelOption).first();
        var wheelElement = $wheel[0];
        var optionElement = $option[0];
        var wheelRect = wheelElement.getBoundingClientRect();
        var optionRect = optionElement.getBoundingClientRect();
        var scrollTop = wheelElement.scrollTop + optionRect.top - wheelRect.top - (wheelElement.clientHeight - optionElement.offsetHeight) / 2;
        var previousSnap = wheelElement.style.scrollSnapType;

        wheelElement.style.scrollSnapType = 'none';
        $wheel.stop(true, true).scrollTop(Math.max(0, scrollTop));
        window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
                wheelElement.style.scrollSnapType = previousSnap;
            });
        });
        $wheel.data('selected-value', String($option.data('value')));
        $wheel.find('.is-selected').removeClass('is-selected');
        $option.addClass('is-selected');
    }

    selectDobWheelOption ($wheel, $option, smooth) {
        if (!$wheel || !$wheel.length || !$option || !$option.length) return;
        var selectedValue = String($option.data('value'));
        $wheel.data('selected-value', selectedValue);
        $wheel.find('.is-selected').removeClass('is-selected');
        $option.addClass('is-selected');

        var _self = this;
        this.scrollWheelToOption($wheel, $option, smooth, function () {
            _self.markDobWheelSelection($wheel);
        });
        if (smooth === false) this.markDobWheelSelection($wheel);
    }

    markDobWheelSelection ($wheel) {
        var closest = this.getWheelCenteredOption($wheel, SELECTORS.dobWheelOption);
        $wheel.find('.is-selected').removeClass('is-selected');
        if (!closest) return;

        var cycleSize = parseInt($wheel.data('cycle-size'), 10);
        var closestIndex = $wheel.find(SELECTORS.dobWheelOption).index(closest);
        if (cycleSize && (closestIndex < cycleSize || closestIndex >= cycleSize * 4)) {
            var centeredIndex = cycleSize * 2 + (closestIndex % cycleSize);
            var centeredOption = $wheel.find(SELECTORS.dobWheelOption).eq(centeredIndex);
            this.scrollWheelToOption($wheel, centeredOption, false);
            closest = centeredOption[0];
        }

        $wheel.data('selected-value', String($(closest).data('value')));
        $(closest).addClass('is-selected');
    }

    getDaysInMonth (year, month) {
        var y = parseInt(year, 10);
        var m = parseInt(month, 10);
        if (isNaN(y) || isNaN(m)) {
            return 31;
        }
        return new Date(y, m, 0).getDate();
    }

    getDobWheelValue ($wheel) {
        return $wheel.data('selected-value') || '';
    }

    updateDobWheelDayRange () {
        var $activeModal = $(SELECTORS.dobWheelModal).not('.hidden');
        if (!$activeModal.length) return;

        var $monthWheel = $activeModal.find(SELECTORS.dobWheel + '[data-wheel="month"]');
        var $yearWheel = $activeModal.find(SELECTORS.dobWheel + '[data-wheel="year"]');
        var $dayWheel = $activeModal.find(SELECTORS.dobWheel + '[data-wheel="day"]');
        if (!$monthWheel.length || !$yearWheel.length || !$dayWheel.length) return;

        var month = parseInt(this.getDobWheelValue($monthWheel), 10) || 1;
        var year = parseInt(this.getDobWheelValue($yearWheel), 10) || new Date().getFullYear() - 30;
        var day = parseInt(this.getDobWheelValue($dayWheel), 10) || 1;
        var maxDay = this.getDaysInMonth(year, month);

        if (parseInt($dayWheel.data('wheel-max'), 10) !== maxDay) {
            this.populateDobWheel('day', 1, maxDay, Math.min(day, maxDay));
        }
    }

    applyDobWheelPicker () {
        var $activeModal = $(SELECTORS.dobWheelModal).not('.hidden');
        if (!$activeModal.length) return;

        var $wheels = $activeModal.find(SELECTORS.dobWheel);
        $wheels.each((index, wheel) => {
            this.markDobWheelSelection($(wheel));
        });
        this.updateDobWheelDayRange();

        var values = {};
        $wheels.each(function () {
            values[$(this).data('wheel')] = $(this).data('selected-value') || '';
        });

        if (!values.day || !values.month || !values.year) return;
        var maxDay = this.getDaysInMonth(values.year, values.month);
        values.day = Math.min(parseInt(values.day, 10), maxDay);
        $(SELECTORS.dobDay).val(String(values.day).padStart(2, '0'));
        $(SELECTORS.dobMonth).val(String(values.month).padStart(2, '0'));
        $(SELECTORS.dobYear).val(values.year);
        this.assembleDob();
        this.syncNativeMobileDateFromSplit();
        $(SELECTORS.dobDay + ', ' + SELECTORS.dobMonth + ', ' + SELECTORS.dobYear).removeClass('parsley-error is-invalid');
        $(SELECTORS.dobMobile).removeClass('parsley-error is-invalid');
        $(SELECTORS.dobMobileField).removeClass('is-invalid').attr('aria-invalid', 'false');
        $(SELECTORS.dobError).text('').hide();
        this.closeDobWheelPicker();
        this.updateButtonStatus();
        this.updateLoyaltyCtaStatus();
    }

    closeDobWheelPicker () {
        $(SELECTORS.dobWheelModal).addClass('hidden');
        $(SELECTORS.dobWheelBackdrop).addClass('hidden');
        $('body').removeClass('cc-dob-wheel-open');
    }

    // ─── Wheel Picker: Phone Prefix (1 Wheel) ────────────────────────

    openPrefixWheelPicker () {
        var $activeStep = $('.tingle-modal:visible ' + SELECTORS.stepPhone + ', .cc-unified-page-card ' + SELECTORS.stepPhone);
        var $modal = $activeStep.find(SELECTORS.prefixWheelModal);
        var $backdrop = $activeStep.find(SELECTORS.prefixWheelBackdrop);

        if (!$modal.length) {
            $modal = $(SELECTORS.prefixWheelModal).first();
            $backdrop = $(SELECTORS.prefixWheelBackdrop).first();
        }

        $modal.removeClass('hidden');
        $backdrop.removeClass('hidden');

        var $wheel = $modal.find(SELECTORS.prefixWheel);
        var $select = $activeStep.find(SELECTORS.phonePrefix);
        if (!$select.length) {
            $select = $(SELECTORS.phonePrefix);
        }
        var currentPrefix = $select.val() || '';

        var _self = this;
        var ns = '.unifiedRegistration';

        $wheel.off('scroll' + ns).on('scroll' + ns, function () {
            clearTimeout(_self.prefixWheelScrollTimer);
            _self.prefixWheelScrollTimer = setTimeout(function () {
                _self.markPrefixWheelSelection($wheel);
            }, 80);
        });

        window.requestAnimationFrame(function () {
            var $targetOption = $wheel.find('.js-prefix-wheel-option[data-value="' + currentPrefix + '"]');
            if ($targetOption.length) {
                _self.selectPrefixWheelOption($wheel, $targetOption, false);
            } else {
                var $firstOption = $wheel.find('.js-prefix-wheel-option').first();
                if ($firstOption.length) {
                    _self.selectPrefixWheelOption($wheel, $firstOption, false);
                }
            }
        });
    }

    selectPrefixWheelOption ($wheel, $option, smooth) {
        if (!$wheel || !$wheel.length || !$option || !$option.length) return;
        var selectedValue = String($option.data('value'));
        $wheel.data('selected-value', selectedValue);
        $wheel.find('.is-selected').removeClass('is-selected');
        $option.addClass('is-selected');

        var _self = this;
        this.scrollWheelToOption($wheel, $option, smooth, function () {
            _self.markPrefixWheelSelection($wheel);
        });
        if (smooth === false) this.markPrefixWheelSelection($wheel);
    }

    markPrefixWheelSelection ($wheel) {
        var closest = this.getWheelCenteredOption($wheel, SELECTORS.prefixWheelOption);
        $wheel.find('.is-selected').removeClass('is-selected');
        if (!closest) return;

        var $closest = $(closest);
        $closest.addClass('is-selected');
        $wheel.data('selected-value', String($closest.data('value')));
    }

    applyPrefixWheelPicker () {
        var $activeStep = $('.tingle-modal:visible ' + SELECTORS.stepPhone + ', .cc-unified-page-card ' + SELECTORS.stepPhone);
        var $modal = $activeStep.find(SELECTORS.prefixWheelModal);
        if (!$modal.length) {
            $modal = $(SELECTORS.prefixWheelModal).first();
        }

        var $wheel = $modal.find(SELECTORS.prefixWheel);
        this.markPrefixWheelSelection($wheel);
        var selectedVal = $wheel.data('selected-value') || $wheel.find('.is-selected').data('value');

        if (selectedVal) {
            var $select = $activeStep.find(SELECTORS.phonePrefix);
            if (!$select.length) {
                $select = $(SELECTORS.phonePrefix);
            }
            $select.val(selectedVal).trigger('change');
        }

        this.closePrefixWheelPicker();
    }

    closePrefixWheelPicker () {
        $(SELECTORS.prefixWheelModal).addClass('hidden');
        $(SELECTORS.prefixWheelBackdrop).addClass('hidden');
    }

    // ─── Wheel Picker: Gender / Title (1 Wheel) ──────────────────────────────

    syncNativeMobileGenderFromRadio () {
        var $activeStep = $(SELECTORS.stepRegister + ':visible');
        var selectedVal = $activeStep.find('input[id^="gender-"]:checked').val();
        if (selectedVal) {
            var text = $activeStep.find(SELECTORS.genderWheelOption + '[data-value="' + selectedVal + '"]').first().text().trim();

            if (text) {
                $activeStep.find(SELECTORS.genderMobileInput).val(text);
                $activeStep.find(SELECTORS.genderMobileField).removeClass('is-invalid').attr('aria-invalid', 'false');
            }
        }
    }

    openGenderWheelPicker () {
        var $activeStep = $(SELECTORS.stepRegister + ':visible');
        var $modal = $activeStep.find(SELECTORS.genderWheelModal);
        var $backdrop = $activeStep.find(SELECTORS.genderWheelBackdrop);

        $modal.removeClass('hidden');
        $backdrop.removeClass('hidden');

        var $wheel = $modal.find(SELECTORS.genderWheel);
        var currentGender = $activeStep.find('input[id^="gender-"]:checked').val() || '1';

        var _self = this;
        var ns = '.unifiedRegistration';

        $wheel.off('scroll' + ns).on('scroll' + ns, function () {
            clearTimeout(_self.genderWheelScrollTimer);
            _self.genderWheelScrollTimer = setTimeout(function () {
                _self.markGenderWheelSelection($wheel);
            }, 80);
        });

        window.requestAnimationFrame(function () {
            var $targetOption = $wheel.find(SELECTORS.genderWheelOption + '[data-value="' + currentGender + '"]');
            var $optionToSelect = $targetOption.length ? $targetOption : $wheel.find(SELECTORS.genderWheelOption).first();
            _self.selectGenderWheelOption($wheel, $optionToSelect, false);
        });
    }

    selectGenderWheelOption ($wheel, $option, smooth) {
        if (!$wheel || !$wheel.length || !$option || !$option.length) return;
        var selectedValue = String($option.data('value'));
        $wheel.data('selected-value', selectedValue);
        $wheel.find('.is-selected').removeClass('is-selected');
        $option.addClass('is-selected');

        var _self = this;
        this.scrollWheelToOption($wheel, $option, smooth, function () {
            _self.markGenderWheelSelection($wheel);
        });
        if (smooth === false) this.markGenderWheelSelection($wheel);
    }

    markGenderWheelSelection ($wheel) {
        var closest = this.getWheelCenteredOption($wheel, SELECTORS.genderWheelOption);
        $wheel.find('.is-selected').removeClass('is-selected');
        if (!closest) return;

        var $closest = $(closest);
        $closest.addClass('is-selected');
        $wheel.data('selected-value', String($closest.data('value')));
    }

    applyGenderWheelPicker () {
        var $activeStep = $(SELECTORS.stepRegister + ':visible');
        var $wheel = $activeStep.find(SELECTORS.genderWheel);
        this.markGenderWheelSelection($wheel);
        var selectedVal = $wheel.data('selected-value') || $wheel.find('.is-selected').data('value');

        if (selectedVal) {
            $activeStep.find('input[id^="gender-"][value="' + selectedVal + '"]').prop('checked', true).trigger('change');
            $activeStep.find('#reg-gender-error').empty();
        }

        this.closeGenderWheelPicker();
        this.updateButtonStatus();
    }

    closeGenderWheelPicker () {
        $(SELECTORS.genderWheelModal).addClass('hidden');
        $(SELECTORS.genderWheelBackdrop).addClass('hidden');
    }

    isValidDate (day, month, year) {
        var d = parseInt(day, 10);
        var m = parseInt(month, 10);
        var y = parseInt(year, 10);

        if (isNaN(d) || isNaN(m) || isNaN(y)) {
            return false;
        }

        if (m < 1 || m > 12) {
            return false;
        }

        var currentYear = new Date().getFullYear();
        if (y < currentYear - 120 || y > currentYear) {
            return false;
        }

        var date = new Date(y, m - 1, d);
        return date.getFullYear() === y && date.getMonth() === (m - 1) && date.getDate() === d;
    }

    isOfAge (day, month, year) {
        var d = parseInt(day, 10);
        var m = parseInt(month, 10);
        var y = parseInt(year, 10);

        if (isNaN(d) || isNaN(m) || isNaN(y)) {
            return false;
        }

        var today = new Date();
        var birthDate = new Date(y, m - 1, d);
        var age = today.getFullYear() - birthDate.getFullYear();
        var mDiff = today.getMonth() - birthDate.getMonth();

        if (mDiff < 0 || (mDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age >= 18;
    }

    validateDob () {
        var $dobWrapper = $(SELECTORS.dobWrapper);
        if (!$dobWrapper.length) return true;

        var day = $(SELECTORS.dobDay).val().trim();
        var month = $(SELECTORS.dobMonth).val().trim();
        var year = $(SELECTORS.dobYear).val().trim();

        if (!day || !month || !year) {
            $(SELECTORS.dobError).text($(SELECTORS.regDob).data('parsley-required-message') || '').show();
            return false;
        }

        if (!this.isValidDate(day, month, year)) {
            var invalidMsg = $dobWrapper.data('invalid-dob-message');
            this.showDobError(invalidMsg);
            return false;
        }

        if (!this.isOfAge(day, month, year)) {
            var underageMsg = $dobWrapper.data('underage-dob-message');
            this.showDobError(underageMsg);
            return false;
        }

        $(SELECTORS.dobError).text('').hide();
        return true;
    }

    getDobErrorMessage (data) {
        return data.birthDateError ||
            (data.fields && data.fields.dwfrm_profile_customer_birthDate) ||
            (data.form && data.form.customer && data.form.customer.birthDate && data.form.customer.birthDate.error) ||
            '';
    }

    showDobError (message) {
        if (!message) return;

        $(SELECTORS.dobError).text(message).show();
        $(SELECTORS.dobDay + ', ' + SELECTORS.dobMonth + ', ' + SELECTORS.dobYear).addClass('is-invalid parsley-error');
        $(SELECTORS.dobMobile).addClass('is-invalid parsley-error');
        $(SELECTORS.dobMobileField).addClass('is-invalid').attr('aria-invalid', 'true');
    }

    // ─── Navigation ──────────────────────────────────────────────────────────

    handleStepBack (e) {
        e.preventDefault();

        if (this.isResetPasswordOpen()) {
            this.closeResetPassword();
            return;
        }

        var $passwordWrapper = $(SELECTORS.passwordWrapper);
        if ($passwordWrapper.is(':visible')) {
            var $emailInput = $(SELECTORS.emailInput);
            $emailInput.removeAttr('readonly').removeClass('cc-is-readonly');

            this.toggleVisible(SELECTORS.loginDescription, true);
            this.toggleVisible(SELECTORS.loginSubtitle, false);
            this.toggleVisible(SELECTORS.passwordWrapper, false);
            this.toggleVisible(SELECTORS.resetPasswordWrapper, false);
            this.toggleVisible(SELECTORS.rememberMeWrapper, false);
            this.toggleVisible(SELECTORS.btnLoginSubmit, false);
            this.toggleVisible(SELECTORS.btnEmailNext, true);
            this.toggleVisible(SELECTORS.socialSection, true);
            this.toggleVisible(SELECTORS.btnStepBack, false);

            $(SELECTORS.passwordInput).val('');
            $emailInput.focus();
            return;
        }

        var $stepPhone = $(SELECTORS.stepPhone);
        if ($stepPhone.is(':visible')) {
            this.updateHeaderTitle('login');
            this.resetPhoneStep();
            this.toggleVisible(SELECTORS.stepPhone, false);
            this.toggleVisible(SELECTORS.stepEmail, true);
            this.toggleVisible(SELECTORS.btnStepBack, false);
            $('body').removeClass('cc-unified-step-active');
            $(SELECTORS.emailInput).focus();
            return;
        }

        var $stepOtp = $(SELECTORS.stepOtp);
        if ($stepOtp.length && $stepOtp.is(':visible')) {
            this.toggleVisible(SELECTORS.stepOtp, false);
            this.toggleVisible(SELECTORS.stepRegister, true);
            return;
        }

        var $stepRegister = $(SELECTORS.stepRegister);
        if ($stepRegister.length && $stepRegister.is(':visible')) {
            $('.login-form-error').html('').hide();
            this.toggleVisible(SELECTORS.stepRegister, false);
            this.toggleVisible(SELECTORS.stepPhone, true);
            $(SELECTORS.phoneInput).focus();
        }
    }

    // ─── Privacy Policy modal ───────────────

    openPrivacyPolicy (url) {
        if (!url) return;

        $.spinner().start();
        $.ajax({
            url: url,
            type: 'GET',
            dataType: 'html'
        }).then(function (data) {
            $.spinner().stop();
            var $fetched = $('<div>').html(data);

            var modalClass = url.indexOf('ProfilingPrivacyPolicy') > -1 ? 'privacy-policy-profiling-popup' : 'privacy-policy-marketing-popup';

            function onClose () {
                if ($('.tingle-modal.tingle-modal--visible').length > 0) {
                    $('body').addClass('tingle-enabled');
                    $('html').addClass('html-tingle-enabled');
                }
            }

            const modal = newModalFromString($fetched.html(), false, [modalClass], null, onClose);
            $(modal.modalBox).addClass('rightModalAttribute cc-register-privacy-policy-modal');
            modal.open();

            $(modal.modalBox)
                .find('.close-button-privacy')
                .on('click', function (e) {
                    modal.close();
                });
        }).fail(function () {
            $.spinner().stop();
        });
    }



    // ─── Reset Password (in-modal step, not a separate popup) ─────────────────

    openResetPassword () {
        if (this.isResetPasswordOpen()) return;

        this.resetPasswordReturnStep = $(SELECTORS.allSteps).not(SELECTORS.stepResetPassword).filter(':visible').first();

        this.toggleVisible(this.resetPasswordReturnStep, false);
        this.showResetPasswordRequest();
        this.toggleVisible(SELECTORS.stepResetPassword, true);
        this.toggleVisible(SELECTORS.btnStepBack, true);

        if (this.isModal()) {
            this.resetPasswordReturnTitle = $(SELECTORS.modalTitle).text();
            $(SELECTORS.modalTitle).text($(SELECTORS.modalTitle).data('reset-password-title') || '');
            $(SELECTORS.modalTitle).addClass('cc-unified-title--reset');
        } else {
            var $pageTitle = $('.cc-unified-page-step-title:visible');
            if ($pageTitle.length) {
                this.resetPasswordPageReturnSelector = $pageTitle;
                this.toggleVisible($pageTitle, false);
            }
            this.toggleVisible('.js-unified-page-step-title--reset-password', true);
        }

        this.handleResetPasswordInputChange();
    }

    closeResetPassword () {
        this.toggleVisible(SELECTORS.stepResetPassword, false);
        if (this.resetPasswordReturnStep && this.resetPasswordReturnStep.length) {
            this.toggleVisible(this.resetPasswordReturnStep, true);
        } else {
            this.toggleVisible(SELECTORS.stepEmail, true);
        }

        if (this.isModal()) {
            if (this.resetPasswordReturnTitle) {
                $(SELECTORS.modalTitle).text(this.resetPasswordReturnTitle);
            }
            $(SELECTORS.modalTitle).removeClass('cc-unified-title--reset');
        } else {
            this.toggleVisible('.js-unified-page-step-title--reset-password', false);
            if (this.resetPasswordPageReturnSelector) {
                this.toggleVisible(this.resetPasswordPageReturnSelector, true);
            }
        }

        this.resetPasswordReturnStep = null;
        this.resetPasswordReturnTitle = null;
        this.resetPasswordPageReturnSelector = null;
        this.showResetPasswordRequest();
        this.clearField(SELECTORS.resetPasswordEmail, SELECTORS.resetPasswordEmailError);
        $(SELECTORS.resetPasswordGenericError).addClass('hidden').empty();
        this.handleResetPasswordInputChange();
    }

    isResetPasswordOpen () {
        return $(SELECTORS.stepResetPassword).is(':visible');
    }

    showResetPasswordRequest () {
        this.toggleVisible(SELECTORS.resetPasswordRequest, true);
        this.toggleVisible(SELECTORS.resetPasswordSuccess, false);
        $(SELECTORS.stepResetPassword).removeClass('cc-step-reset-password--success');
    }

    handleResetPasswordInputChange () {
        var isFilled = ($(SELECTORS.resetPasswordEmail).val() || '').trim() !== '';
        $('.js-btn-reset-password-submit').prop('disabled', !isFilled);
    }

    handleResetPasswordSubmit () {
        var _self = this;
        var $form = $(SELECTORS.resetPasswordForm);
        var $emailInput = $(SELECTORS.resetPasswordEmail);

        $emailInput.parsley().validate();
        if (!$emailInput.parsley().isValid()) return;

        if (this.isSubmitting) return;
        this.isSubmitting = true;
        $.spinner().start();

        $(SELECTORS.resetPasswordGenericError).addClass('hidden').empty();

        $.ajax({
            url: $form.attr('action'),
            type: 'POST',
            dataType: 'json',
            data: $form.serialize()
        }).done(function (data) {
            $.spinner().stop();
            if (!data.success) {
                if (data.fields && data.fields.loginEmail) {
                    $(SELECTORS.resetPasswordEmailError).text(data.fields.loginEmail).removeClass('invisible');
                    $emailInput.addClass('is-invalid');
                } else {
                    $(SELECTORS.resetPasswordGenericError).text(data.error || '').removeClass('hidden');
                }
                return;
            }

            $(SELECTORS.resetPasswordSuccessBody).text(data.receivedMsgBody || '');
            _self.toggleVisible(SELECTORS.resetPasswordRequest, false);
            _self.toggleVisible(SELECTORS.resetPasswordSuccess, true);
            _self.toggleVisible(SELECTORS.btnStepBack, false);
            $(SELECTORS.stepResetPassword).addClass('cc-step-reset-password--success');

            if (!_self.isModal()) {
                _self.toggleVisible('.js-unified-page-step-title--reset-password', false);
            }
        }).fail(function () {
            $.spinner().stop();
            $(SELECTORS.resetPasswordGenericError).text('').removeClass('hidden');
        }).always(function () {
            _self.isSubmitting = false;
        });
    }

    // ─── Reset helpers ───────────────────────────────────────────────────────

    resetPhoneStep () {
        this.clearField(SELECTORS.phoneInput, null);
        this.clearField(SELECTORS.phoneOtpInput, SELECTORS.phoneOtpError);
        $(SELECTORS.phoneOtpInput).removeAttr('required');
        $(SELECTORS.phoneOtpWrapper).addClass('hidden');
        $(SELECTORS.phoneStepEmailRecap).text('');
        $(SELECTORS.phoneNextBtn).prop('disabled', true);
        $(SELECTORS.phoneError).empty().removeClass('login-form-error-block success-block hide');
        $(SELECTORS.phoneOtpProceedButton).removeClass('underline-border');
    }

    resetWizard () {
        this.privacyReturnStep = null;
        this.privacyReturnBtnStepBack = false;
        this.resetPasswordReturnStep = null;
        this.resetPasswordReturnTitle = null;
        this.showResetPasswordRequest();
        this.clearField(SELECTORS.resetPasswordEmail, SELECTORS.resetPasswordEmailError);
        $(SELECTORS.resetPasswordGenericError).addClass('hidden').empty();
        this.updateHeaderTitle('login');
        this.clearField(SELECTORS.emailInput, SELECTORS.emailError, { removeReadonly: true });
        this.clearField(SELECTORS.passwordInput, SELECTORS.passwordError);
        this.resetPhoneStep();
        this.handleEmailInputChange();
        this.handleLoginPasswordInputChange();

        this.toggleVisible(SELECTORS.loginDescription, true);
        this.toggleVisible(SELECTORS.loginSubtitle, false);
        this.toggleVisible(SELECTORS.passwordWrapper, false);
        this.toggleVisible(SELECTORS.resetPasswordWrapper, false);
        this.toggleVisible(SELECTORS.rememberMeWrapper, false);
        this.toggleVisible(SELECTORS.btnLoginSubmit, false);
        this.toggleVisible(SELECTORS.btnEmailNext, true);
        this.toggleVisible(SELECTORS.socialSection, true);
        this.toggleVisible(SELECTORS.btnStepBack, false);
        $('body').removeClass('cc-unified-step-active');

        // Customer Service Flow
        if ($('#scFlowActive').length && $('#scFlowActive').val() === 'true') {
            var scEmail = $('#scEmail').val() || $(SELECTORS.emailInput).val() || '';
            var scPhone = $('#scPhone').val() || '';
            var scPhonePrefix = $('#scPhonePrefix').val() || '';
            var scFlow = $('#scFlow').val() || '';
            var hiddenPhonePlaceholder = $('#hiddenPhonePlaceholder').val() || '';

            var scTargetStep = 'email';
            if (scFlow === '1') {
                scTargetStep = 'phone';
            } else if (scFlow === '2') {
                scTargetStep = 'register';
            }

            this.prefillAndTransition({
                email: scEmail,
                phone: scPhone,
                prefix: scPhonePrefix,
                targetStep: scTargetStep,
                hiddenPhonePlaceholder: hiddenPhonePlaceholder
            });
            return;
        }

        if ($('#orderConfirmationFlowActive').length && $('#orderConfirmationFlowActive').val() === 'true') {
            var ocEmail = $('#ocEmail').val() || '';
            var ocPhone = $('#ocPhone').val() || '';
            var ocPhonePrefix = $('#ocPhonePrefix').val() || '';
            var ocFirstName = $('#ocFirstName').val() || '';
            var ocLastName = $('#ocLastName').val() || '';

            this.prefillAndTransition({
                email: ocEmail,
                phone: ocPhone,
                prefix: ocPhonePrefix,
                firstName: ocFirstName,
                lastName: ocLastName,
                targetStep: 'email'
            });
            return;
        }

        $(SELECTORS.allSteps).addClass('hidden').removeClass('active').hide();
        this.toggleVisible(SELECTORS.stepEmail, true);
    }

    // ─── Utilities ───────────────────────────────────────────────────────────

    toggleVisible (selector, visible) {
        var $el = $(selector);
        if (visible) {
            $el.removeClass('hidden cc-unified-back-invisible').addClass('active').show();
        } else {
            $el.addClass('hidden').removeClass('active').hide();
        }
    }

    clearField (inputSelector, errorSelector, options) {
        var opts = options || {};
        var $input = $(inputSelector);
        if ($input.length) {
            $input.val('').removeClass('parsley-error is-invalid');
            if (opts.removeReadonly) {
                $input.removeAttr('readonly').removeClass('cc-is-readonly');
            }
        }
        if (errorSelector) {
            var $error = $(errorSelector);
            if ($error.length) {
                $error.text('').hide();
            }
        }
    }

    showValidationError ($input, $errorEl, errorMsg) {
        $input.addClass('parsley-error');
        $errorEl.text(errorMsg).show();
    }

    /**
     * Prefill the fields of the unified wizard and transition to the desired step.
     * @param {Object} config - Configuration of the user fields and target step
     */
    prefillAndTransition (config) {
        var email = config.email || '';
        var phone = config.phone || '';
        var prefix = config.prefix || '';
        var firstName = config.firstName || '';
        var lastName = config.lastName || '';
        var targetStep = config.targetStep || 'email'; // Values: 'email', 'phone', 'register'
        var hiddenPhonePlaceholder = config.hiddenPhonePlaceholder || '';

        if (email) {
            $(SELECTORS.emailInput).val(email).trigger('input');
            $(SELECTORS.regEmailRecap).text(email);
            $(SELECTORS.phoneStepEmailRecap).text(email);
        }
        if (prefix) {
            $(SELECTORS.phonePrefix).val(prefix).trigger('change');
            $('.js-hidden-prefix').val(prefix);
        }
        if (targetStep === 'phone' && hiddenPhonePlaceholder) {
            $(SELECTORS.phoneInput).val('');
        } else if (phone) {
            $(SELECTORS.phoneInput).val(phone).trigger('input');
            $('.js-hidden-phone').val(phone);
        }
        if (prefix && phone) {
            $(SELECTORS.regPhoneRecap).text(prefix + phone);
        }
        if (firstName) {
            $(SELECTORS.regFirstName).val(firstName).trigger('input');
        }
        if (lastName) {
            $(SELECTORS.regLastName).val(lastName).trigger('input');
        }

        $(SELECTORS.allSteps).addClass('hidden').removeClass('active').hide();

        if (targetStep === 'phone') {
            this.updateHeaderTitle('login');
            this.toggleVisible(SELECTORS.stepPhone, true);
            this.initPhonePrefixChosen();
            this.updatePrefixDisplay();

            $(SELECTORS.phoneInput).focus();
        } else if (targetStep === 'register') {
            this.updateHeaderTitle('register');
            this.toggleVisible(SELECTORS.stepRegister, true);
        } else {
            this.updateHeaderTitle('login');
            this.toggleVisible(SELECTORS.stepEmail, true);
        }

        this.updateButtonStatus();
        this.updatePasswordOverlay($('.cc-asterisk-pwd-wrapper ' + SELECTORS.passwordInput));
        this.updatePasswordOverlay($('.cc-asterisk-pwd-wrapper #registration-form-password'));
        this.updatePasswordOverlay($('.cc-asterisk-pwd-wrapper #registration-form-password-confirm'));
    }

    /**
     * Synchronizes the asterisk overlay with the actual value of the corresponding password input field.
     * Visually generates a '*' character for each character currently present in the underlying transparent input.
     * @param {jQuery} $input - The targeted password input field element.
     */
    updatePasswordOverlay ($input) {
        if (!$input || !$input.length) return;
        var $overlay = $input.siblings('.js-asterisk-pwd-overlay');
        if ($overlay.length) {
            $overlay.text('*'.repeat($input.val().length));
        }
    }

    // ─── Email & Login Password Input Status ─────────────────────────────────

    handleEmailInputChange () {
        var isFilled = ($(SELECTORS.emailInput).val() || '').trim() !== '';
        $(SELECTORS.btnEmailNext).prop('disabled', !isFilled);
    }

    handleLoginPasswordInputChange () {
        var isPasswordFilled = ($(SELECTORS.passwordInput).val() || '').trim() !== '';
        $(SELECTORS.btnLoginSubmit).prop('disabled', !isPasswordFilled);
    }

    // ─── Password Strength Verification ──────────────────────────────────────

    handlePasswordInput () {
        var $passwordInput = $('#registration-form-password');
        var val = $passwordInput.val() || '';
        var $staticTip = $('.js-password-tip-static');
        var $checklist = $('.js-password-checklist');

        if (val.length > 0 || $passwordInput.is(':focus')) {
            $staticTip.addClass('hidden');
            $checklist.removeClass('hidden');

            // Perform regex criteria evaluations
            var hasLength = val.length >= 8;
            var hasUppercase = /[A-Z]/.test(val);
            var hasLowercase = /[a-z]/.test(val);
            var hasNumber = /[0-9]/.test(val);
            var hasSpecial = /[^A-Za-z0-9]/.test(val);

            $('.js-password-rule-length').toggleClass('is-complete', hasLength);
            $('.js-password-rule-uppercase').toggleClass('is-complete', hasUppercase);
            $('.js-password-rule-lowercase').toggleClass('is-complete', hasLowercase);
            $('.js-password-rule-number').toggleClass('is-complete', hasNumber);
            $('.js-password-rule-special').toggleClass('is-complete', hasSpecial);
        } else {
            $staticTip.removeClass('hidden');
            $checklist.addClass('hidden');
        }
    }

    validatePasswordStrength (password) {
        var hasLength = password.length >= 8;
        var hasUppercase = /[A-Z]/.test(password);
        var hasLowercase = /[a-z]/.test(password);
        var hasNumber = /[0-9]/.test(password);
        var hasSpecial = /[^A-Za-z0-9]/.test(password);
        return hasLength && hasUppercase && hasLowercase && hasNumber && hasSpecial;
    }

    // ─── Step 4: OTP Waiting Room ────────────────────────────────────────────

    /**
     * The click fires before the browser native validation: when required fields (gender, privacy, dob...)
     * are missing the submit event is never dispatched, so the Step 3 error must be tracked here.
     * @param {HTMLElement} btn - submit button
     */
    handleRegisterSubmitClick (btn) {
        var form = $(btn).closest('form').get(0);
        if (this.isSubmitting || !form || typeof form.checkValidity !== 'function' || form.checkValidity()) {
            return;
        }

        // Analytics tracking Step 3 Error (client-side validation)
        this.trackRegisterThird(true);
    }

    trackRegisterThird (isError, isSocial) {
        this.trackRegistrationStep('customer:registerThird', isError, {
            'typeOfAccount': this.getTypeOfAccount(),
            'rememberMe': $('#rememberMeRegister').prop('checked'),
            // Landing page: step 4 fires on the thank you page load (social has its own thank you events)
            'thankYouPageOnLoad': !isError && !isSocial && !this.isModal()
        });
    }

    handleRegisterSubmit (e) {
        var _self = this;
        var $form = $(SELECTORS.registerForm);

        if (!this.validateDob()) {
            // Analytics tracking Step 3 Error (client-side validation)
            this.trackRegisterThird(true);
            return;
        }

        if (this.isSubmitting) return;
        this.isSubmitting = true;
        $.spinner().start();

        // Clear previous form errors
        $('.login-form-error').html('').hide();
        $('.login-form-error-generic').addClass('hidden');

        var isModal = this.isModal();
        var dataForm = $form.serialize();
        if (isModal) {
            dataForm += '&isModalFlow=true';
        }

        $.ajax({
            url: $form.attr('action'),
            type: 'POST',
            dataType: 'json',
            data: dataForm,
            success: function (data) {
                $.spinner().stop();
                if (data.success) {
                    var isSocial = $('#isSocialRegistration').val() === 'true';

                    // Analytics tracking Step 3 Success
                    _self.trackRegisterThird(false, isSocial);

                    if (isSocial) {
                        if (data.redirectUrl) {
                            window.location.href = data.redirectUrl;
                        }
                    } else if (isModal) {
                        // Transition to OTP verification step instead of direct redirection
                        _self.transitionToOtp();

                        // Analytics tracking Step 4
                        $('body').trigger('customer:registerThankYouPage', {
                            'typeOfAccount': _self.getTypeOfAccount(),
                            'regFlowPosition': _self.getRegFlowPosition()
                        });
                    } else if (data.redirectUrl) {
                        // Standalone page: same double opt-in confirmation email/page as the as-is flow
                        window.location.href = data.redirectUrl;
                    }
                } else {
                    _self.showDobError(_self.getDobErrorMessage(data));

                    var errMsg = data.error
                        ? (Array.isArray(data.error) ? data.error.join('<br/>') : data.error)
                        : (data.message || 'Error during registration.');

                    // Analytics tracking Step 3 Error
                    _self.trackRegisterThird(true);

                    $('.login-form-error').html(errMsg).show();
                    $('.login-form-error-generic').removeClass('hidden');
                }
            },
            error: function () {
                $.spinner().stop();
                var $error = $('.login-form-error:visible').first();
                if (!$error.length) {
                    $error = $('.login-form-error');
                }
                var genericMsg = $error.data('error-technical');

                // Analytics tracking Step 3 Error
                _self.trackRegisterThird(true);

                $error.html(genericMsg).show();
                $('.login-form-error-generic').removeClass('hidden');
            }
        }).always(function () {
            _self.isSubmitting = false;
        });
    }

    transitionToOtp () {
        this.updateHeaderTitle('confirmation');
        this.toggleVisible(SELECTORS.stepRegister, false);
        this.toggleVisible(SELECTORS.stepOtp, true);
        $(SELECTORS.btnStepBack).addClass('cc-unified-back-invisible');

        // Reset submission flag to allow OTP confirmation click
        this.isSubmitting = false;

        var $container = $(SELECTORS.stepOtp);

        // Populate dynamic recap on OTP step (Email and Phone)
        $container.find('.js-otp-recap-email').text($(SELECTORS.emailInput).val().trim());
        $container.find('.js-otp-recap-phone').text(
            $(SELECTORS.phonePrefix).val().trim() + ' ' + $(SELECTORS.phoneInput).val().trim()
        );

        // Reset OTP input fields
        $container.find('.otp-code-input-field').val('');
        $container.find('.js-register-otp').prop('disabled', true);

        // Reset visibility of localized ISML errors
        $container.find(SELECTORS.wrongOtpError).addClass('hidden');
        $container.find(SELECTORS.expiredOtpError).addClass('hidden');
        $container.find(SELECTORS.otpErrorsWrapper).addClass('hidden');
        $('.js-unified-otp-expiration-tip').removeClass('hidden');

        // Focus on the first OTP input field
        $container.find('.otp-code-input-field').first().focus();
    }

    handleOtpKeyup (e, input) {
        var $container = $(input).closest('.js-step-otp, .registration-modal-waiting');
        var $inputs = $container.find('.otp-code-input-field');
        var currentIndex = $inputs.index(input);
        var val = $(input).val();

        // If user presses Backspace and input is empty, move focus to the previous input
        if (e.keyCode === 8 && val.length === 0) {
            var $prev = $inputs.eq(currentIndex - 1);
            if ($prev.length) {
                $prev.focus();
            }
        }
        // If a digit is entered, move focus to the next input
        else if (val.length > 0) {
            var $next = $inputs.eq(currentIndex + 1);
            if ($next.length) {
                $next.focus();
            }
        }

        // Check if all 5 OTP fields are filled to enable submit button
        var isFilled = $inputs.get().every(function (inp) {
            return $(inp).val().trim() !== '';
        });

        $container.find(SELECTORS.otpConfirmBtn).prop('disabled', !isFilled);
    }

    handleOtpConfirm (e) {
        e.preventDefault();
        var _self = this;
        if (this.isSubmitting) return;

        var $confirmBtn = $(e.currentTarget);
        var $container = $confirmBtn.closest('.js-step-otp, .registration-modal-waiting');
        var url = $confirmBtn.data('registration-otp-url');
        if (!url) {
            console.error('Unified Registration: Missing OTP Confirmation URL.');
            return;
        }

        this.isSubmitting = true;
        $.spinner().start();

        // Reset visibility of localized error messages before verification
        $('.js-unified-otp-expiration-tip').removeClass('hidden');
        $container.find(SELECTORS.wrongOtpError).addClass('hidden');
        $container.find(SELECTORS.expiredOtpError).addClass('hidden');
        $container.find(SELECTORS.otpErrorsWrapper).addClass('hidden');

        var email = $(SELECTORS.emailInput).val().trim();
        var otpCodeInput = '';
        $container.find('.otp-code-input-field').each(function () {
            otpCodeInput += $(this).val();
        });

        $.ajax({
            url: url,
            type: 'GET',
            data: {
                email: email,
                otpCodeInput: otpCodeInput
            },
            success: function (data) {
                $.spinner().stop();
                if (data.success) {
                    // Analytics tracking Step 4 Double Opt-in Success
                    _self.trackConfirmOptin(false);

                    // Log the user in after successful registration and reload the page
                    _self.loginAfterRegistration();
                } else {
                    // Analytics tracking Step 4 Double Opt-in Error
                    _self.trackConfirmOptin(true);
                    $('.js-unified-otp-expiration-tip').addClass('hidden');
                    if (data.expiredOtp) {
                        $container.find(SELECTORS.expiredOtpError).removeClass('hidden');
                        $container.find(SELECTORS.wrongOtpError).addClass('hidden');
                    } else {
                        $container.find(SELECTORS.wrongOtpError).removeClass('hidden');
                        $container.find(SELECTORS.expiredOtpError).addClass('hidden');
                    }
                    $container.find(SELECTORS.otpErrorsWrapper).removeClass('hidden');
                }
            },
            error: function () {
                $.spinner().stop();

                // Analytics tracking Step 4 Double Opt-in Error
                _self.trackConfirmOptin(true);

                $('.js-unified-otp-expiration-tip').addClass('hidden');
                $container.find(SELECTORS.wrongOtpError).removeClass('hidden');
                $container.find(SELECTORS.expiredOtpError).addClass('hidden');
                $container.find(SELECTORS.otpErrorsWrapper).removeClass('hidden');
            }
        }).always(function () {
            _self.isSubmitting = false;
        });
    }

    loginAfterRegistration () {
        var url = $('form.login').attr('action');
        var email = $(SELECTORS.emailInput).val().trim();
        var password = $('#registration-form-password').val();
        var csrfToken = $('input[name="csrf_token"]').val();
        var rememberMeRegisterChecked = $('#rememberMeRegister').prop('checked');
        var rememberMeChecked = rememberMeRegisterChecked ? 'on' : null;
        var formData = {
            loginEmail: email,
            loginPassword: password,
            csrf_token: csrfToken,
            loginRememberMe: rememberMeChecked
        };
        $.spinner().start();

        $.ajax({
            url: url,
            type: 'POST',
            dataType: 'json',
            data: formData,
            success: function (data) {
                $.spinner().stop();
                if (data.success) {
                    $('form.login').trigger('login:success', data);
                    location.reload();
                } else {
                    // Fallback to Home page if automatic login fails for some reason
                    window.location.href = window.location.origin;
                }
            },
            error: function () {
                $.spinner().stop();
                window.location.href = window.location.origin;
            }
        });
    }

    updateHeaderTitle (stage) {
        var $title = $(SELECTORS.modalTitle);
        if (!$title.length) return;

        if (stage === 'login') {
            $title.text($title.data('login-title') || '');
            $title.removeClass('cc-unified-title-register');
        } else if (stage === 'register') {
            $title.text($title.data('register-title') || '');
            $title.addClass('cc-unified-title-register');
        } else if (stage === 'confirmation') {
            $title.text($title.data('confirmation-title') || '');
            $title.addClass('cc-unified-title-register');
        }
    }

    proceedToUnifiedRegistrationLoyaltyInit (e) {
        if (e) {
            e.preventDefault();
        }
        if (!this.isModal()) {
            history.pushState({ stage: 'registration' }, '');
        }
        $('.registrationModal-box').attr('data-registration-modal-stage', 'registration');
        $('.js-unified-loyalty-registration-or-delete-container').addClass('hidden');
        $('.js-unified-account-confirmation-delete-modal').addClass('hidden');
        $('.js-unified-loyalty-registration-container').removeClass('hidden');
        $(SELECTORS.dobError).text('').hide();

        this.updateLoyaltyCtaStatus();
    }

    updateLoyaltyCtaStatus () {
        var day = $('#dob-day').length ? $('#dob-day').val().trim() : '';
        var month = $('#dob-month').length ? $('#dob-month').val().trim() : '';
        var year = $('#dob-year').length ? $('#dob-year').val().trim() : '';

        var isValid = (day.length === 2 && !isNaN(day)) &&
                      (month.length === 2 && !isNaN(month)) &&
                      (year.length === 4 && !isNaN(year)) &&
                      this.isValidDate(day, month, year) &&
                      this.isOfAge(day, month, year);

        var $submitBtn = $('.js-unified-loyalty-registration-container button[type="submit"]');
        if ($submitBtn.length) {
            if (isValid) {
                $submitBtn.prop('disabled', false).removeClass('disabledForm');
            } else {
                $submitBtn.prop('disabled', true).addClass('disabledForm');
            }
        }
    }

    handleLoyaltyRegisterSubmit (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var _self = this;
        var $form = $(e.currentTarget);
        var url = $form.attr('action');
        var $submitBtn = $form.find('button[type="submit"]');

        if (this.isSubmitting) return;
        if ($submitBtn.is(':disabled')) return;

        this.isSubmitting = true;
        $submitBtn.prop('disabled', true).attr('aria-busy', 'true');
        $.spinner().start();

        $form.find('.login-form-error').html('').hide();

        var dataForm = $form.serialize();

        $.ajax({
            url: url,
            type: 'POST',
            dataType: 'json',
            data: dataForm,
            success: (data) => {
                $.spinner().stop();
                if (data.success) {
                    // Analytics tracking Loyalty Card Subscription (EventID: 13)
                    // Already registered user: only the digital loyalty card is created
                    $('body').trigger('customer:registerLoyalty', 'only_loyalty');

                    $('.js-unified-loyalty-registration-container').addClass('hidden');
                    $('.js-unified-loyalty-registration-success').removeClass('hidden');
                    if (this.isModal()) {
                        $(SELECTORS.btnStepBack).addClass('cc-unified-last-hide-arrow');
                    }
                    this.currentRegistrationOrDeleteStage = 'registrationComplete';
                } else {
                    $submitBtn.prop('disabled', false).removeAttr('aria-busy');
                    $form.find('.form-fields-item__input-field').addClass('is-invalid parsley-error');
                    this.showDobError(this.getDobErrorMessage(data));
                }
            },
            error: function () {
                $.spinner().stop();
                $submitBtn.prop('disabled', false).removeAttr('aria-busy');
                $form.find('.form-fields-item__input-field').addClass('is-invalid parsley-error');
            }
        }).always(function () {
            _self.isSubmitting = false;
        });
    }

    confirmationDeleteAccount () {
        if (!this.isModal()) {
            history.pushState({ stage: 'delete' }, '');
        }
        $('.registrationModal-box').attr('data-registration-modal-stage', 'delete');
        $('.js-unified-loyalty-registration-or-delete-container').addClass('hidden');
        $('.js-unified-account-confirmation-delete-modal').removeClass('hidden');
    }

    handleAccountDeleteConfirmation () {
        // Ajax call to the account delete service
        var url = $('#unifiedAccountDeleteConfirmModal').data('account-delete-url');
        $.spinner().start();
        $.ajax({
            url: url,
            method: 'GET',
            success: data => {
                if (data.error) {
                    onErrorHandler();
                } else {
                    $('body').trigger('analytics:accountRemoveConfirmation');
                    $('#accountCancellationModalStep1').addClass('hidden');
                    $('#accountCancellationModalSuccess').removeClass('hidden');
                    $(SELECTORS.btnStepBack).addClass('hidden');
                    this.currentRegistrationOrDeleteStage = 'deleteComplete';
                    $.spinner().stop();
                }
            },
            error: data => {
                onErrorHandler();
            }
        });
        function onErrorHandler () {
            $('#accountCancellationModalStep1').addClass('hidden');
            $('#accountCancellationModalError').removeClass('hidden');
            $.spinner().stop();
        }
    }

    unifiedLogout () {
        if (window.Urls && window.Urls.logout) {
            window.location.href = window.Urls.logout;
        }
    }

    unifiedCloseModalReloadOrLogout () {
        var _self = this;
        var isUserLogged = $('#registrationLoyaltyModal').attr('data-unified-user-logged') === 'true';

        if (this.currentRegistrationOrDeleteStage === 'registrationComplete' || this.currentRegistrationOrDeleteStage === 'deleteComplete') {
            location.reload();
        } else if (isUserLogged) {
            _self.unifiedLogout();
        }
    }

    unifiedLoyaltybuttonBackInit () {
        var _self = this;

        if (this.isModal()) {
            $(SELECTORS.btnStepBack).on('click', function (e) {
                var $registrationModal = $('.registrationModal-box');
                var currentStep = $registrationModal.attr('data-registration-modal-stage');
                switch (currentStep) {
                case 'content':
                    $('.js-close-unified-registration-or-delete-modal').trigger('click');
                    break;
                case 'registration' :
                    $registrationModal.attr('data-registration-modal-stage', 'content');
                    $('.js-unified-loyalty-registration-or-delete-container').removeClass('hidden');
                    $('.js-unified-loyalty-registration-container').addClass('hidden');
                    break;
                case 'delete':
                    $registrationModal.attr('data-registration-modal-stage', 'content');
                    $('.js-unified-loyalty-registration-or-delete-container').removeClass('hidden');
                    $('.js-unified-account-confirmation-delete-modal').addClass('hidden');
                    break;
                }
            });
        } else {
            history.replaceState({ stage: 'content' }, '');

            $(window).off('popstate.unifiedLoyalty').on('popstate.unifiedLoyalty', (e) => {
                if (_self.currentRegistrationOrDeleteStage === 'registrationComplete' || _self.currentRegistrationOrDeleteStage === 'deleteComplete') {
                    location.reload();
                    return;
                }

                var state = e.originalEvent.state;
                var $registrationModal = $('.registrationModal-box');

                if (state && state.stage) {
                    $registrationModal.attr('data-registration-modal-stage', state.stage);

                    if (state.stage === 'content') {
                        $('.js-unified-loyalty-registration-or-delete-container').removeClass('hidden');
                        $('.js-unified-loyalty-registration-container').addClass('hidden');
                        $('.js-unified-account-confirmation-delete-modal').addClass('hidden');
                    } else if (state.stage === 'registration') {
                        $('.js-unified-loyalty-registration-or-delete-container').addClass('hidden');
                        $('.js-unified-loyalty-registration-container').removeClass('hidden');
                        $('.js-unified-account-confirmation-delete-modal').addClass('hidden');
                    } else if (state.stage === 'delete') {
                        $('.js-unified-loyalty-registration-or-delete-container').addClass('hidden');
                        $('.js-unified-loyalty-registration-container').addClass('hidden');
                        $('.js-unified-account-confirmation-delete-modal').removeClass('hidden');
                    }
                }
            });
        }
    }

    unifiedModalLoyaltyRegistrationInit () {
        var _self = this;
        $('.js-unified-modal-loyalty-registration').on('click', function (e) {
            e.preventDefault();
            let url = $('#registrationLoyaltyModalURL').data('url');
            if (!url) {
                console.error('Missing URL for AJAX call');
                return;
            }
            $.ajax(url).then(data => {

                if (!_self.isModal()) {
                    var innerContent = $(data).find('#registrationModal-box');
                    $('.js-unified-flow-container').html(innerContent);
                    $('.js-unified-page-card .js-unified-page-step-title--login').addClass('cc-unified-hidden-important');
                    if ($('.js-thankYouPage').length) {
                        $('.js-thankYouPage').addClass('hidden');
                        $('.js-categoryThanks').addClass('hidden');
                    }
                } else {
                    $('.js-unified-flow-container').html(data);
                }

                RegistrationHelper.datePickerInit();

                $('.js-unified-loyalty-registration-container .js-dob-part').on('input', function () {
                    _self.updateLoyaltyCtaStatus();
                });

                Customer.accountRegisterForm();
                RegistrationHelper.proceedToRegistrationLoyaltyInit();
                _self.unifiedLoyaltybuttonBackInit();
                RegistrationHelper.moveToNextStep('content');
            });
        });
    }

    isTouchCapable () {
        return window.matchMedia && window.matchMedia('(hover: none)').matches;
    }

    showInfoTooltip ($wrapper) {
        var $tooltip = $wrapper.children('.tooltip');
        if (!$tooltip.length || $tooltip.hasClass('is-visible')) return;

        $tooltip.addClass('is-visible');
        window.requestAnimationFrame(() => {
            this.positionInfoTooltip($wrapper);
        });
    }

    hideInfoTooltip ($wrapper) {
        var $tooltip = $wrapper.children('.tooltip');
        $tooltip.removeClass('is-visible');
        $tooltip.css({
            position: '',
            left: '',
            top: '',
            transform: ''
        });
    }

    positionInfoTooltip ($wrapper) {
        var $tooltip = $wrapper.children('.tooltip');
        if (!$tooltip.length) return;

        var margin = 16;
        var gap = 8;
        var iconRect = $wrapper[0].getBoundingClientRect();
        var tooltipRect = $tooltip[0].getBoundingClientRect();
        var viewportWidth = window.innerWidth;

        var left = iconRect.left + (iconRect.width / 2) - (tooltipRect.width / 2);
        left = Math.min(Math.max(left, margin), viewportWidth - tooltipRect.width - margin);

        var top = -tooltipRect.height - gap;
        var arrowLeft = (iconRect.left + (iconRect.width / 2)) - left;
        var arrowMargin = 16;
        arrowLeft = Math.min(Math.max(arrowLeft, arrowMargin), tooltipRect.width - arrowMargin);

        $tooltip.css({
            position: 'absolute',
            left: (left - iconRect.left) + 'px',
            top: top + 'px',
            transform: 'none'
        });
        $tooltip[0].style.setProperty('--tooltip-arrow-left', arrowLeft + 'px');
    }

    // clears the field where the “x” icon appears
    handleInputClear (e) {
        e.preventDefault();
        e.stopPropagation();
        var $input = $(e.currentTarget).siblings('#unified-phone');
        if ($input.length > 0) {
            $input.val('')
                .removeClass('cc-isPrefilled is-invalid is-invalid-input parsley-error')
                .attr('aria-invalid', 'false');
            var $label = $(e.currentTarget).closest('.form-fields-item__label');
            $label.removeClass('focused');
            $label.find('.errors-list').empty();
            $label.siblings('.invalid-feedback').empty().hide();
        }
    }

    initPhonePrefixChosen () {
        if (!$.fn.chosen) return;

        var $selects = $('.tingle-modal:visible #unified-phone-prefix, .cc-unified-page-card #unified-phone-prefix');
        if (!$selects.length) {
            $selects = $(SELECTORS.phonePrefix);
        }

        $selects.each(function () {
            var $select = $(this);
            $select.next('.chosen-container').remove();
            $select.removeClass('chosen-done').removeData('chosen');
            $select.chosen({
                disable_search: true,
                width: '100%'
            });
        });
    }

    updatePrefixDisplay () {
        var $activeStep = $(SELECTORS.stepPhone + ':visible');
        var $select = $activeStep.length ? $activeStep.find(SELECTORS.phonePrefix) : $(SELECTORS.phonePrefix);
        var selectedValue = $select.val() || '';

        $activeStep.find(SELECTORS.prefixMobileTrigger).text(selectedValue);

        if ($.fn.chosen) {
            $select.trigger('chosen:updated');
            $select.next('.chosen-container').find('.chosen-single span').text(selectedValue);
        }
    }
}

const unifiedRegistration = new UnifiedRegistration();
export default unifiedRegistration;
